import { Component, ElementRef, ViewChild, OnInit, Inject, NgZone, PLATFORM_ID } from '@angular/core';
import { CoopServiceService } from '../../../services/Coop/coop-service.service';
import { AuthenService } from '../../../services/Authen/authen.service';
import { NgxSpinnerService } from "ngx-spinner";
import { isPlatformBrowser } from '@angular/common';
import { registerLocaleData } from '@angular/common';

import { Router, ActivatedRoute } from '@angular/router';
import he from '@angular/common/locales/he';
import Swal from 'sweetalert2';

import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import am4themes_dataviz from "@amcharts/amcharts4/themes/dataviz";

import { callable, session_year } from "src/app/components/callable";

@Component({
  selector: 'app-coop-info',
  templateUrl: './coop-info.component.html',
  styleUrls: ['./coop-info.component.scss']
})
export class CoopInfoComponent implements OnInit {

  constructor(
    @Inject(PLATFORM_ID) private platformId, private zone: NgZone,

    private CoopServiceService: CoopServiceService,
    private AuthenService: AuthenService,
    private router: Router,
    private SpinnerService: NgxSpinnerService,
    private activatedRoute: ActivatedRoute,
    private elementRef: ElementRef
  ) {

    this.UrlPath = activatedRoute.snapshot.url;
  }

  year_now: any;
  datayear: any;
  OrgOrgId: any;
  provinceName: any;
  UrlPath: any
  List: any;
  Info: any;
  PhakId: any;
  KhetId: any;
  MemberSum: any;
  CommitteeSum: any;
  CoopStandardProvinceYearBySearch: any;
  persent_standard_not: any;
  persent_standard_pass: any;
  sumstandard: any;
  nonActive: any;
  active: any;
  sumstActive: any;
  persent_status_active: any;
  persent_status_nonActive: any;
  CoopStatusProvinceYearBySearch: any;
  EndmonthYear: any;
  searchText: any;
  listCoop: any;
  sumResult_: any;
  coopId: any;
  CoopBusinessEachProvince: any;
  item: any;
  RubberDistributorProvinceYear: any;
  RubberProductProvinceYearBySearch: any;
  CoopBusinessTypeProvinceYear: any;
  pageOfItems: Array<any>;
  asset: any;
  machine: any;
  product: any;
  business: any;
  AssetYear: any;
  check_Length_3: any;
  check_Length_4: any;
  MachinesByRegister: any;
  rice: any;
  rubber: any;
  cpd: any;
  CoopOracleCount: any
  CoopOracleCountactive: any
  CoopOracleCountnonActive: any
  MemberYearDataSum: any = 0
  MemberYearDataFm: any = 0
  MemberYearDataM: any = 0
  year_now_: any
  Date_now: any
  Date_after_day: any
  Month_now: any
  Month_now_: any
  datayear_Lst: any
  Committee: any;
  CommitteeYear: any = 0;
  CommitteeYearM: any = 0;
  CommitteeYearFM: any = 0;
  CoopOfficerYearMember: any = 0;
  CoopOfficerYearMemberM: any = 0;
  CoopOfficerYearMemberFm: any = 0;
  StandardTypeSum_pass: any = 0
  StandardTypeSum_notPass: any = 0

  StandardType_pass_level1: any
  StandardType_notPass_level1: any

  StandardType_pass_level2: any
  StandardType_notPass_level2: any

  StandardType_pass_level3: any
  StandardType_notPass_level3: any

  StandardType_pass_level4: any
  StandardType_notPass_level4: any

  StandardType_pass_level5: any
  StandardType_notPass_level5: any

  StandardType_pass_level6: any
  StandardType_notPass_level6: any

  StandardType_pass_level7: any
  StandardType_notPass_level7: any
  CoopOracleTypes: any
  Active_coopType1: any = 0;
  InActive_coopType1: any = 0;
  typeName: any

  CoopTypeLevelCount: any;
  TypeLevelSum1: any = 0;
  TypeLevelSum2: any = 0;
  TypeLevelSum3: any = 0;
  TypeLevelSum4: any = 0;
  TypeLevel1_type1: any = 0;
  TypeLevel1_type2: any = 0;
  TypeLevel1_type3: any = 0;
  TypeLevel1_type4: any = 0;
  TypeLevel1_type5: any = 0;
  TypeLevel1_type6: any = 0;
  TypeLevel1_type7: any = 0;

  TypeLevel2_type1: any = 0;
  TypeLevel2_type2: any = 0;
  TypeLevel2_type3: any = 0;
  TypeLevel2_type4: any = 0;
  TypeLevel2_type5: any = 0;
  TypeLevel2_type6: any = 0;
  TypeLevel2_type7: any = 0;

  TypeLevel3_type1: any = 0;
  TypeLevel3_type2: any = 0;
  TypeLevel3_type3: any = 0;
  TypeLevel3_type4: any = 0;
  TypeLevel3_type5: any = 0;
  TypeLevel3_type6: any = 0;
  TypeLevel3_type7: any = 0;

  TypeLevel4_type1: any = 0;
  TypeLevel4_type2: any = 0;
  TypeLevel4_type3: any = 0;
  TypeLevel4_type4: any = 0;
  TypeLevel4_type5: any = 0;
  TypeLevel4_type6: any = 0;
  TypeLevel4_type7: any = 0;

  valSum1: any = 0
  valSum2: any = 0
  valSum3: any = 0
  valSum4: any = 0
  valSum5: any = 0

  defect_data: any;
  defect_on = false;
  verify_defect = false;
  auth_data: any;

  ViewOAE_1: any;
  ViewOAE_2: any;
  ViewOAE_3: any;
  ViewOAE_1_detail: any;
  ViewOAE_2_detail: any;
  ViewOAE_3_detail: any;
  rubber_sum: any;

  yearData = callable.checkYearNow();
  listYear = callable.listYear();
  listsector = callable.getMasterSector();
  sector_now = callable.getCurrentSector();

  StandardTypeSumClose = true ;
  CoopLevelCountClose = true ;

  ngOnInit(): void {
    this.SpinnerService.show();
    // this.verify_role();
    this.year_now = callable.getCurrentYear();
    this.year_now_ = ((new Date()).getFullYear()) + 543;

    this.get_date_now_and_after();
    this.datayear = this.year_now;
    this.datayear_Lst = this.year_now + 1;

    for (let i = 0; i < this.UrlPath.length; i++) {
      this.provinceName = this.UrlPath[1].path;
    }

    this.GetOrgidByPath();
    this.get_auth_verify();

    this.Info = true;
    this.PhakId = "null";
    this.KhetId = "null";

    this.rice = true;
    this.asset = true;
    this.product = true;

    this.GetCoopMemberEachProvinceLastestYear();
    this.GetCoopStandardTypeSum();
    this.viewgraph();
    this.GetCoopBusinessTypeProvinceYear();
    this.GetCoopOracleCountNEW();
    this.GetCoopMemberProvinceYearSearch();
    this.GetCoopCommitteeYear();
    this.GetCoopSumOfficer();
    this.GetViewOAEByGroup()
    this.GetViewRubberSumProvinceTotal();
    this.GetCoopOracleTypes();
    this.GetCoopTypeLevelCount();
    this.SpinnerService.hide();

    registerLocaleData(he);

  }

  selectNewYearAndSector(year, sector) {
    if (year) {
      this.year_now = callable.getCurrentYear(year);
    }

    if (sector) {
      this.sector_now = callable.getCurrentSector(sector);
    }

    this.yearData = callable.checkYearNow();

    this.get_date_now_and_after();
    this.datayear = this.year_now;
    this.datayear_Lst = this.year_now + 1;

    // this.Info = true;
    this.PhakId = "null";
    this.KhetId = "null";

    this.rice = true;
    this.asset = true;
    this.product = true;

    this.GetCoopMemberEachProvinceLastestYear();
    this.GetCoopStandardTypeSum();
    this.GetCoopBusinessTypeProvinceYear();
    this.GetCoopOracleCountNEW();
    this.GetCoopMemberProvinceYearSearch();
    this.GetCoopCommitteeYear();
    this.GetCoopSumOfficer();
    this.GetViewOAEByGroup()
    this.GetViewRubberSumProvinceTotal();
    this.GetCoopOracleTypes();
    this.GetCoopTypeLevelCount();

    registerLocaleData(he);

    setTimeout(() => {
      this.viewgraph();
    }, 500);

    setTimeout(() => {
      this.SpinnerService.hide();
      // sessionStorage.removeItem(session_year);
    }, 1000);
  }

  verify_role() {
    let user = JSON.parse(localStorage.getItem("access_token"));
    if (user && user['role'] == 'Admin') {
      this.router.navigate(["/user-management"]);
    }
  }

  get_auth_verify() {
    this.auth_data = JSON.parse(localStorage.getItem("access_token"));
    if (this.auth_data != null) {
      this.AuthenService.Get_manage_role(this.auth_data['role']).subscribe(
        responce => {
          if (this.auth_data['role'] == 'Admin') {
            this.defect_on = true;
            this.verify_defect = true;
            this.GetDefectProvinceYearSum();
          } else {
            this.AuthenService.GetProvinceByUserid(this.auth_data['user_id']).subscribe(
              res => {
                for (let i = 0; i < responce.length; i++) {
                  if (responce[i]['menu'] == 'ข้อบกพร่อง' && responce[i]['status'] == 'y') {
                    this.defect_on = true;
                  } else {
                    this.defect_on = false;
                  }
                }

                //Check role
                if (this.auth_data['role'] == 'Executive' || this.auth_data['role'] == 'Central_agency') {
                  this.verify_defect = true;
                } else {
                  for (let j = 0; j < res.length; j++) {
                    if (res[j]['orgOrgId'].trim() == this.OrgOrgId) {
                      this.verify_defect = true;
                      break;
                    }
                  }
                }
                this.GetDefectProvinceYearSum();
              }
            );
          }
        }
      );
    }
  }

  get_date_now_and_after() {
    let Date_today = new Date();
    this.Date_after_day = new Date(Date_today);
    this.Date_after_day.setDate(this.Date_after_day.getDate() - 1);
    this.Month_now = this.Date_after_day.getMonth() + 1;
    this.Date_now = Date_today.getDate()
    this.Date_after_day = this.Date_after_day.getDate()

    if (this.Month_now == '1') {
      this.Month_now_ = "มกราคม";
    }
    else if (this.Month_now == '2') {
      this.Month_now_ = "กุมภาพันธ์";
    }
    else if (this.Month_now == '3') {
      this.Month_now_ = "มีนาคม";
    }
    else if (this.Month_now == '4') {
      this.Month_now_ = "เมษายน";
    }
    else if (this.Month_now == '5') {
      this.Month_now_ = "พฤษภาคม";
    }
    else if (this.Month_now == '6') {
      this.Month_now_ = "มิถุนายน";
    }
    else if (this.Month_now == '7') {
      this.Month_now_ = "กรกฏาคม";
    }
    else if (this.Month_now == '8') {
      this.Month_now_ = "สิงหาคม";
    }
    else if (this.Month_now == '9') {
      this.Month_now_ = "กันยายน";
    }
    else if (this.Month_now == '10') {
      this.Month_now_ = "ตุลาคม";
    }
    else if (this.Month_now == '11') {
      this.Month_now_ = "พฤศจิกายน";
    }
    else if (this.Month_now == '12') {
      this.Month_now_ = "ธันวาคม";
    }
  }

  onChangePage(pageOfItems: Array<any>) {
    // update current page of items
    this.pageOfItems = pageOfItems;
  }

  GetOrgidByPath() {
    if (this.provinceName == "กรุงเทพมหานคร") {
      this.OrgOrgId = "4553";

    }
    else if (this.provinceName == "กำแพงเพชร") {
      this.OrgOrgId = "4849";
    }
    else if (this.provinceName == "เชียงราย") {
      this.OrgOrgId = "4925";

    }
    else if (this.provinceName == "เชียงใหม่") {
      this.OrgOrgId = "4895";

    }
    else if (this.provinceName == "ตาก") {
      this.OrgOrgId = "4857";
    }
    else if (this.provinceName == "นครสวรรค์") {
      this.OrgOrgId = "4842";
    }
    else if (this.provinceName == "น่าน") {
      this.OrgOrgId = "4931";
    }
    else if (this.provinceName == "พะเยา") {
      this.OrgOrgId = "4917";
    }
    else if (this.provinceName == "พิจิตร") {
      this.OrgOrgId = "4883";
    }
    else if (this.provinceName == "พิษณุโลก") {
      this.OrgOrgId = "4876";
    }
    else if (this.provinceName == "เพชรบูรณ์") {
      this.OrgOrgId = "4889";
    }
    else if (this.provinceName == "แพร่") {
      this.OrgOrgId = "4937";
    }
    else if (this.provinceName == "แม่ฮ่องสอน") {
      this.OrgOrgId = "4942";
    }
    else if (this.provinceName == "ลำปาง") {
      this.OrgOrgId = "4910";
    }
    else if (this.provinceName == "ลำพูน") {
      this.OrgOrgId = "4904";
    }
    else if (this.provinceName == "สุโขทัย") {
      this.OrgOrgId = "4864";
    }
    else if (this.provinceName == "อุตรดิตถ์") {
      this.OrgOrgId = "4948";
    }
    else if (this.provinceName == "อุทัยธานี") {
      this.OrgOrgId = "4835";
    }
    else if (this.provinceName == "กาญจนบุรี") {
      this.OrgOrgId = "4750";
    }
    else if (this.provinceName == "จันทบุรี") {
      this.OrgOrgId = "4803";
    }
    else if (this.provinceName == "ฉะเชิงเทรา") {
      this.OrgOrgId = "4786";
    }
    else if (this.provinceName == "ชลบุรี") {
      this.OrgOrgId = "4792";
    }
    else if (this.provinceName == "ชัยนาท") {
      this.OrgOrgId = "4718";
    }
    else if (this.provinceName == "ตราด") {
      this.OrgOrgId = "4808";
    }
    else if (this.provinceName == "นครนายก") {
      this.OrgOrgId = "4829";
    }
    else if (this.provinceName == "นครปฐม") {
      this.OrgOrgId = "4738";
    }
    else if (this.provinceName == "นนทบุรี") {
      this.OrgOrgId = "4668";
    }
    else if (this.provinceName == "ปทุมธานี") {
      this.OrgOrgId = "4674";
    }
    else if (this.provinceName == "ประจวบคีรีขันธ์") {
      this.OrgOrgId = "4773";
    }
    else if (this.provinceName == "ปราจีนบุรี") {
      this.OrgOrgId = "4814";
    }
    else if (this.provinceName == "พระนครศรีอยุธยา") {
      this.OrgOrgId = "4686";
    }
    else if (this.provinceName == "เพชรบุรี") {
      this.OrgOrgId = "4764";
    }
    else if (this.provinceName == "ระยอง") {
      this.OrgOrgId = "4798";
    }
    else if (this.provinceName == "ราชบุรี") {
      this.OrgOrgId = "4744";
    }
    else if (this.provinceName == "ลพบุรี") {
      this.OrgOrgId = "4704";
    }
    else if (this.provinceName == "สมุทรปราการ") {
      this.OrgOrgId = "4780";
    }
    else if (this.provinceName == "สมุทรสงคราม") {
      this.OrgOrgId = "4732";
    }
    else if (this.provinceName == "สมุทรสาคร") {
      this.OrgOrgId = "4724";
    }
    else if (this.provinceName == "สระแก้ว") {
      this.OrgOrgId = "4821";
    }
    else if (this.provinceName == "สระบุรี") {
      this.OrgOrgId = "4711";
    }
    else if (this.provinceName == "สิงห์บุรี") {
      this.OrgOrgId = "4698";
    }
    else if (this.provinceName == "สุพรรณบุรี") {
      this.OrgOrgId = "4757";
    }
    else if (this.provinceName == "อ่างทอง") {
      this.OrgOrgId = "4692";
    }
    else if (this.provinceName == "กาฬสินธุ์") {
      this.OrgOrgId = "5059";
    }
    else if (this.provinceName == "ขอนแก่น") {
      this.OrgOrgId = "5007";
    }
    else if (this.provinceName == "ชัยภูมิ") {
      this.OrgOrgId = "4963";
    }
    else if (this.provinceName == "นครพนม") {
      this.OrgOrgId = "5027";
    }
    else if (this.provinceName == "นครราชสีมา") {
      this.OrgOrgId = "4956";
    }
    else if (this.provinceName == "บึงกาฬ") {
      this.OrgOrgId = "5504";
    }
    else if (this.provinceName == "บุรีรัมย์") {
      this.OrgOrgId = "4970";
    }
    else if (this.provinceName == "มหาสารคาม") {
      this.OrgOrgId = "5045";
    }
    else if (this.provinceName == "มุกดาหาร") {
      this.OrgOrgId = "5051";
    }
    else if (this.provinceName == "ยโสธร") {
      this.OrgOrgId = "5001";
    }
    else if (this.provinceName == "ร้อยเอ็ด") {
      this.OrgOrgId = "5065";
    }
    else if (this.provinceName == "เลย") {
      this.OrgOrgId = "5033";
    }
    else if (this.provinceName == "ศรีสะเกษ") {
      this.OrgOrgId = "4983";
    }
    else if (this.provinceName == "สกลนคร") {
      this.OrgOrgId = "5039";
    }
    else if (this.provinceName == "สุรินทร์") {
      this.OrgOrgId = "4977";
    }
    else if (this.provinceName == "หนองคาย") {
      this.OrgOrgId = "5021";
    }
    else if (this.provinceName == "หนองบัวลำภู") {
      this.OrgOrgId = "5015";
    }
    else if (this.provinceName == "อำนาจเจริญ") {
      this.OrgOrgId = "4995";
    }
    else if (this.provinceName == "อุดรธานี") {
      this.OrgOrgId = "5014";
    }
    else if (this.provinceName == "อุบลราชธานี") {
      this.OrgOrgId = "4989";
    }
    else if (this.provinceName == "กระบี่") {
      this.OrgOrgId = "5104";
    }
    else if (this.provinceName == "ชุมพร") {
      this.OrgOrgId = "5071";
    }
    else if (this.provinceName == "ตรัง") {
      this.OrgOrgId = "5130";
    }
    else if (this.provinceName == "นครศรีธรรมราช") {
      this.OrgOrgId = "5095";
    }
    else if (this.provinceName == "นราธิวาส") {
      this.OrgOrgId = "5153";
    }
    else if (this.provinceName == "ปัตตานี") {
      this.OrgOrgId = "5147";
    }
    else if (this.provinceName == "พังงา") {
      this.OrgOrgId = "5103";
    }
    else if (this.provinceName == "พัทลุง") {
      this.OrgOrgId = "5129";
    }
    else if (this.provinceName == "ภูเก็ต") {
      this.OrgOrgId = "5117";
    }
    else if (this.provinceName == "ยะลา") {
      this.OrgOrgId = "5141";
    }
    else if (this.provinceName == "ระนอง") {
      this.OrgOrgId = "5080";
    }
    else if (this.provinceName == "สงขลา") {
      this.OrgOrgId = "5123";
    }

    else if (this.provinceName == "สุราษฎร์ธานี") {
      this.OrgOrgId = "5086";
    }
    else if (this.provinceName == "สตูล") {
      this.OrgOrgId = "5161";
    }
  }

  GetCoopOracleTypes() {
    this.CoopServiceService.GetCoopOracleTypes(this.OrgOrgId, this.PhakId, this.KhetId).subscribe(res => {
      this.CoopOracleTypes = res;
      this.Active_coopType1 = 0;
      this.InActive_coopType1 = 0;
      for (let i = 0; i < res.length; i++) {

        this.Active_coopType1 += res[i].active;
        this.InActive_coopType1 += res[i].nonActive;
        if (res[i].coopType == "1") {
          this.typeName = "สหกรณ์การเกษตร";
        }
        else if (res[i].coopType == "2") {
          this.typeName = "สหกรณ์ประมง";
        }
        else if (res[i].coopType == "3") {
          this.typeName = "สหกรณ์นิคม";
        }
        else if (res[i].coopType == "4") {
          this.typeName = "สหกรณ์ออมทรัพย์";
        }
        else if (res[i].coopType == "5") {
          this.typeName = "สหกรณ์ร้านค้า";
        }
        else if (res[i].coopType == "6") {
          this.typeName = "สหกรณ์บริการ";
        }
        else if (res[i].coopType == "7") {
          this.typeName = "สหกรณ์เครดิตยูเนี่ยน";
        }
      }

    })

  }

  GetCoopTypeLevelCount() {
    this.CoopServiceService.GetCoopTypeLevelCount(this.OrgOrgId, this.PhakId, this.KhetId).subscribe(res => {
      this.CoopTypeLevelCount = res;
      this.TypeLevelSum1 = 0;
      this.TypeLevelSum2 = 0;
      this.TypeLevelSum3 = 0;
      this.TypeLevelSum4 = 0;
      for (let i = 0; i < res.length; i++) {

        if (res[i].level == "1") {
          this.TypeLevelSum1 += res[i].count;
          if (res[i].type == "1") {
            this.TypeLevel1_type1 = res[i].count;
          }
          else if (res[i].type == "2") {
            this.TypeLevel1_type2 = res[i].count;
          }
          else if (res[i].type == "3") {
            this.TypeLevel1_type3 = res[i].count;
          }
          else if (res[i].type == "4") {
            this.TypeLevel1_type4 = res[i].count;
          }
          else if (res[i].type == "5") {
            this.TypeLevel1_type5 = res[i].count;
          }
          else if (res[i].type == "6") {
            this.TypeLevel1_type6 = res[i].count;
          }
          else if (res[i].type == "7") {
            this.TypeLevel1_type7 = res[i].count;
          }
        }
        else if (res[i].level == "2") {
          this.TypeLevelSum2 += res[i].count;
          if (res[i].type == "1") {
            this.TypeLevel2_type1 = res[i].count;
          }
          else if (res[i].type == "2") {
            this.TypeLevel2_type2 = res[i].count;
          }
          else if (res[i].type == "3") {
            this.TypeLevel2_type3 = res[i].count;
          }
          else if (res[i].type == "4") {
            this.TypeLevel2_type4 = res[i].count;
          }
          else if (res[i].type == "5") {
            this.TypeLevel2_type5 = res[i].count;
          }
          else if (res[i].type == "6") {
            this.TypeLevel2_type6 = res[i].count;
          }
          else if (res[i].type == "7") {
            this.TypeLevel2_type7 = res[i].count;
          }
        }
        else if (res[i].level == "3") {
          this.TypeLevelSum3 += res[i].count;
          if (res[i].type == "1") {
            this.TypeLevel3_type1 = res[i].count;
          }
          else if (res[i].type == "2") {
            this.TypeLevel3_type2 = res[i].count;
          }
          else if (res[i].type == "3") {
            this.TypeLevel3_type3 = res[i].count;
          }
          else if (res[i].type == "4") {
            this.TypeLevel3_type4 = res[i].count;
          }
          else if (res[i].type == "5") {
            this.TypeLevel3_type5 = res[i].count;
          }
          else if (res[i].type == "6") {
            this.TypeLevel3_type6 = res[i].count;
          }
          else if (res[i].type == "7") {
            this.TypeLevel3_type7 = res[i].count;
          }
        }
        else if (res[i].level == "4") {
          this.TypeLevelSum4 += res[i].count;

          if (res[i].type == "1") {
            this.TypeLevel4_type1 = res[i].count;
          }
          else if (res[i].type == "2") {
            this.TypeLevel4_type2 = res[i].count;
          }
          else if (res[i].type == "3") {
            this.TypeLevel4_type3 = res[i].count;
          }
          else if (res[i].type == "4") {
            this.TypeLevel4_type4 = res[i].count;
          }
          else if (res[i].type == "5") {
            this.TypeLevel4_type5 = res[i].count;
          }
          else if (res[i].type == "6") {
            this.TypeLevel4_type6 = res[i].count;
          }
          else if (res[i].type == "7") {
            this.TypeLevel4_type7 = res[i].count;
          }
        }
      }
    })
  }

  select_Info(data) {
    this.Info = data;
    if (this.Info == "Info") {
      this.Info = true;
      this.List = false;
    }

    this.viewgraph();
  }

  select_List(data) {
    this.selectProvice_Search();
    this.List = data;
    if (this.List == "List") {
      this.Info = false;
      this.List = true;
    }

    this.viewgraph();
  }

  Assets(data) {
    this.asset = data;
    if (this.asset == 'asset') {
      this.asset = true;
      this.machine = false;
      this.product = false;
      this.business = false;
    }
  }

  Machine(data) {
    this.machine = data;
    if (this.machine == 'machine') {
      this.asset = false;
      this.machine = true;
      this.product = false;
      this.business = false;
    }

  }

  Rice(data) {
    this.rice = data;
    if (this.rice == 'rice') {
      this.rice = true;
      this.rubber = false;
      this.cpd = false;
    }


  }

  Rubber(data) {

    this.rubber = data;
    if (this.rubber == 'rubber') {
      this.rubber = true;
      this.rice = false;
      this.cpd = false;

    }

  }

  CPD(data) {

    this.cpd = data;
    if (this.cpd == 'cpd') {
      this.cpd = true;
      this.rice = false;
      this.rubber = false;
    }

  }

  GetAssetYear() {
    // this.CoopServiceService.GetAssetYear(this.coopId).subscribe(res => {
    //   this.AssetYear = res;

    //   if (res.length == 0) {
    //     this.check_Length_3 = true;
    //   } else {
    //     this.check_Length_3 = false;

    //   }
    // })
  }

  GetMachinesByRegister() {
    // this.CoopServiceService.GetMachinesByRegister(this.coopId).subscribe(res => {
    //   this.MachinesByRegister = res;
    //   if (res.length == 0) {
    //     this.check_Length_4 = true;
    //   } else {
    //     this.check_Length_4 = false;

    //   }
    // })
  }

  GetCoopOracleCountNEW() {
    this.CoopServiceService.GetCoopOracleCountNEW(this.OrgOrgId, this.PhakId, this.KhetId).subscribe(res => {
      this.CoopOracleCount = 0;
      this.CoopOracleCountactive = 0;
      this.CoopOracleCountnonActive = 0;

      for (let i = 0; i < res.length; i++) {
        this.CoopOracleCount += res[i].coopCount;
        this.CoopOracleCountactive += res[i].active;
        this.CoopOracleCountnonActive += res[i].nonActive;
      }
    })
  }

  GetCoopMemberProvinceYearSearch() {
    // this.CoopServiceService.GetCoopMemberEachProvinceLastestYear(this.OrgOrgId, this.PhakId, this.KhetId).subscribe(res => {
    //   this.MemberYearDataSum = 0;
    //   this.MemberYearDataM = 0;
    //   this.MemberYearDataFm = 0;

    //   for (let i = 0; i < res.length; i++) {
    //     this.MemberYearDataSum += res[i].sum;
    //     this.MemberYearDataM += res[i].dataM;
    //     this.MemberYearDataFm += res[i].dataFm;
    //   }
    // })

    this.CoopServiceService.GetCoopSumMember(this.OrgOrgId, this.PhakId, this.KhetId).subscribe(res => {
      this.MemberYearDataSum = 0;
      this.MemberYearDataM = 0;
      this.MemberYearDataFm = 0;
      for (let i = 0; i < res.length; i++) {
        this.MemberYearDataSum += res[i].sum;
        this.MemberYearDataM += res[i].dataM;
        this.MemberYearDataFm += res[i].dataFm;
      }
    });
  }

  GetCoopCommitteeYear() {
    this.CoopServiceService.GetCoopSumCommittee(this.OrgOrgId, this.PhakId, this.KhetId).subscribe(res => {
      this.CommitteeYearM = 0;
      this.CommitteeYearFM = 0;
      this.Committee = 0;
      this.CommitteeYear = 0;

      for (let i = 0; i < res.length; i++) {
        this.CommitteeYearM += res[i].dataM;
        this.CommitteeYearFM += res[i].dataFm;
        this.Committee = res[i].sum;
        this.CommitteeYear += this.Committee;
      }
    })
  }

  GetCoopStandardTypeSum() {
    this.CoopServiceService.GetCoopStandardTypeSum(this.OrgOrgId, this.PhakId, this.KhetId).subscribe(res => {
      this.StandardTypeSum_pass = 0;
      this.StandardTypeSum_notPass = 0;
      if( res.length == 0){
        this.StandardTypeSumClose = true ;
      }else{
          this.StandardTypeSumClose = false ;
      }




      for (let i = 0; i < res.length; i++) {

        this.StandardTypeSum_pass += res[i].pass;
        this.StandardTypeSum_notPass += res[i].notPass;

        if (res[i].coopType == "1") {
          this.StandardType_pass_level1 = res[i].pass;
          this.StandardType_notPass_level1 = res[i].notPass;
        }
        else if (res[i].coopType == "2") {
          this.StandardType_pass_level2 = res[i].pass;
          this.StandardType_notPass_level2 = res[i].notPass;
        }
        else if (res[i].coopType == "3") {
          this.StandardType_pass_level3 = res[i].pass;
          this.StandardType_notPass_level3 = res[i].notPass;
        }
        else if (res[i].coopType == "4") {
          this.StandardType_pass_level4 = res[i].pass;
          this.StandardType_notPass_level4 = res[i].notPass;
        }
        else if (res[i].coopType == "5") {
          this.StandardType_pass_level5 = res[i].pass;
          this.StandardType_notPass_level5 = res[i].notPass;
        }
        else if (res[i].coopType == "6") {
          this.StandardType_pass_level6 = res[i].pass;
          this.StandardType_notPass_level6 = res[i].notPass;
        }
        else if (res[i].coopType == "7") {
          this.StandardType_pass_level7 = res[i].pass;
          this.StandardType_notPass_level7 = res[i].notPass;
        }
      }


     if(this.StandardTypeSum_pass==0){
         this.StandardTypeSumClose = true ;
      }

    })
  }

  GetCoopSumOfficer() {
    this.CoopServiceService.GetCoopSumOfficer(this.OrgOrgId, this.PhakId, this.KhetId).subscribe(res => {

      this.CoopOfficerYearMember = 0;
      this.CoopOfficerYearMemberM = 0;
      this.CoopOfficerYearMemberFm = 0;

      for (let i = 0; i < res.length; i++) {
        this.CoopOfficerYearMember += res[i].sum;
        this.CoopOfficerYearMemberM += res[i].dataM;
        this.CoopOfficerYearMemberFm += res[i].dataFm;
      }
    })
  }

  GetCoopBusinessEachProvince() {
    // this.CoopServiceService.GetCoopBusinessEachProvince(this.datayear, this.OrgOrgId).subscribe(res => {
    //   this.CoopBusinessEachProvince = res;
    // })
  }

  GetCoopMemberEachProvinceLastestYear() {
    this.SpinnerService.show();
    if (this.PhakId != undefined && this.KhetId != undefined && this.OrgOrgId != undefined) {
      this.CoopServiceService.GetCoopMemberEachProvinceLastestYear(this.OrgOrgId, this.PhakId, this.KhetId).subscribe(res => {

        for (let i = 0; i < res.length; i++) {
          this.MemberSum = res[i].sumData;

        }
      });
    }
  }

  // GetCoopStandardProvinceYearBySearch() {
  //   if (this.PhakId != undefined && this.KhetId != undefined && this.OrgOrgId != undefined) {
  //     this.CoopServiceService.GetCoopStandardProvinceYearBySearch(this.OrgOrgId, this.PhakId, this.KhetId).subscribe(res => {
  //       for (let i = 0; i < res.length; i++) {

  //         if (res[res.length - 1].dataYear) {
  //           this.CoopStandardProvinceYearBySearch = res;

  //           this.sumstandard = res[i].notPass + res[i].pass;

  //           this.persent_standard_not = ((res[i].notPass / this.sumstandard) * 100)
  //           this.persent_standard_pass = ((res[i].pass / this.sumstandard) * 100)
  //         }

  //       }
  //     });
  //   }
  // }

  // GetCoopStatusProvinceYearBySearch() {
  //   if (this.PhakId != undefined && this.KhetId != undefined && this.OrgOrgId != undefined) {
  //     this.CoopServiceService.GetCoopStatusProvinceYearBySearch(this.OrgOrgId, this.PhakId, this.KhetId).subscribe(res => {

  //       this.CoopStatusProvinceYearBySearch = res;

  //       for (let i = 0; i < res.length; i++) {

  //         this.active = res[i].active;
  //         this.nonActive = res[i].nonActive;

  //         this.sumstActive = res[i].sum;

  //         this.persent_status_active = ((res[i].active / this.sumstActive) * 100);
  //         this.persent_status_nonActive = ((res[i].nonActive / this.sumstActive) * 100);

  //       }
  //     });
  //   }
  // }

  // GetRubberDistributorProvinceYear() {
  //   if (this.PhakId != undefined && this.KhetId != undefined && this.OrgOrgId != undefined) {
  //     this.CoopServiceService.GetRubberDistributorProvinceYear(this.OrgOrgId, this.PhakId, this.KhetId).subscribe(res => {

  //       this.RubberDistributorProvinceYear = res;

  //     });
  //   }
  // }

  // GetRubberProductProvinceYearBySearch() {
  //   if (this.PhakId != undefined && this.KhetId != undefined && this.OrgOrgId != undefined) {
  //     this.CoopServiceService.GetRubberProductProvinceYearBySearch(this.OrgOrgId, this.PhakId, this.KhetId).subscribe(res => {

  //       this.RubberProductProvinceYearBySearch = res;

  //     });
  //   }
  // }

  GetCoopBusinessTypeProvinceYear() {
    if (this.PhakId != undefined && this.KhetId != undefined && this.OrgOrgId != undefined) {
      this.CoopServiceService.GetCoopBusinessTypeProvinceYear(this.OrgOrgId, this.PhakId, this.KhetId).subscribe(res => {

        this.CoopBusinessTypeProvinceYear = res;

      });
    }
  }

  GetDefectProvinceYearSum() {
    if (this.defect_on && this.verify_defect) {
      this.CoopServiceService.GetDefectProvinceYearSum(this.OrgOrgId, this.PhakId, this.KhetId).subscribe(
        res => {
          for (let i = 0; i < res.length; i++) {
            res[i]['lossValue'] = res[i]['lossValue'].toLocaleString();
          }
          this.defect_data = res;
        }
      );
    }
  }


  selectProvice_Search() {
    this.SpinnerService.show();
    this.CoopServiceService.GetCoopList(this.OrgOrgId, this.PhakId, this.KhetId).subscribe(res => {
      this.listCoop = res;
      // this.listCoop = Array(res.length).fill(0).map((x, i) => ({ coopNameTh: res[i].coopNameTh, stdCode: res[i].stdCode, member: res[i].member, coopId: res[i].coopId }));
      this.sumResult_ = res.length;
      this.SpinnerService.hide();
    });
  }

  selectCoopProfile(coopName) {
    const index = this.listCoop.findIndex(element => element.coopNameTh == coopName);
    this.coopId = this.listCoop[index]['coopId'];
    if (this.coopId != undefined) {
      sessionStorage.setItem('coopId', this.coopId);
      this.router.navigate(["/ProfileCoop"]);
    }
    if (this.coopId == undefined) {
      Swal.fire('Warnning', 'กำลังโหลดข้อมูล กรุณาเลือกอีกครั้ง', 'warning');
    }
  }

  GetViewOAEByGroup() {
    this.CoopServiceService.GetViewOAEByGroup(this.OrgOrgId, this.PhakId, this.KhetId).subscribe(
      response => {
        for (let i = 0; i < response.length; i++) {
          response[i]['total_count'] = response[i]['total_count'].toLocaleString();
          response[i]['total_rai'] = response[i]['total_rai'].toLocaleString();
          if (response[i]['groupCode'] == "1") {
            this.ViewOAE_1 = response[i];
          } else if (response[i]['groupCode'] == "2") {
            this.ViewOAE_2 = response[i];
          } else {
            this.ViewOAE_3 = response[i];
          }
        }
      }
    );
  }

  GetViewOAEDetailByGroup(groupCode) {
    let get = true;
    if (groupCode == 1) {
      if (!this.ViewOAE_1_detail) {
        get = false;
      }
    } else if (groupCode == 2) {
      if (!this.ViewOAE_2_detail) {
        get = false;
      }
    } else {
      if (!this.ViewOAE_3_detail) {
        get = false;
      }
    }

    if (get == false) {
      this.SpinnerService.show();
      this.CoopServiceService.GetViewOAEDetailByGroup(this.OrgOrgId, this.PhakId, this.KhetId, groupCode).subscribe(
        response => {
          for (let i = 0; i < response.length; i++) {
            response[i]['total_count'] = response[i]['total_count'].toLocaleString();
            response[i]['total_rai'] = response[i]['total_rai'].toLocaleString();
          }

          if (groupCode == 1) {
            this.ViewOAE_1_detail = response;
          } else if (groupCode == 2) {
            this.ViewOAE_2_detail = response;
          } else {
            this.ViewOAE_3_detail = response;
          }
          this.SpinnerService.hide();
        }
      );
    }
  }

  GetViewRubberSumProvinceTotal() {
    this.CoopServiceService.GetViewRubberSumProvinceTotal(this.OrgOrgId, this.PhakId, this.KhetId).subscribe(
      response => {
        if (response.length != 0) {
          response[0]['total_count'] = response[0]['total_count'].toLocaleString();
          response[0]['total_rai'] = response[0]['total_rai'].toLocaleString();
          this.rubber_sum = response[0];
        }
      }
    );
  }


  browserOnly(f: () => void) {
    if (isPlatformBrowser(this.platformId)) {
      this.zone.runOutsideAngular(() => {
        f();
      });
    }
  }

  browserOnly_Regis(f: () => void) {
    if (isPlatformBrowser(this.platformId)) {
      this.zone.runOutsideAngular(() => {
        f();
      });
    }
  }

  myModal() {

    this.CoopServiceService.GetCoopBussiness(this.OrgOrgId, this.PhakId, this.KhetId).subscribe(res => {
      res = callable.shiftYear(res, this.yearData);
      // เก่า model
      // ปริมารธุรกิจ รับฝากเงิน
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_deposit", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();
        let data = [];
        let net = "หน่วย : ล้านบาท"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].deposit_val) {
            data.push({
              "year": res[i].year,
              "value": res[i].deposit_val
            })

          }
        }

        chart.data = data;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจ ประเภทรับฝากเงิน";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจ ประเภทรับฝากเงิน";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        // Create axes
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;

        categoryAxis.fontSize = "11px"
        //categoryAxis.title.text = "ปีชุดข้อมูล"

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.minWidth = 50;
        valueAxis.fontSize = "11px"
        valueAxis.title.text = net

        // Create series
        let series = chart.series.push(new am4charts.ColumnSeries());
        series.sequencedInterpolation = true;
        series.dataFields.valueY = "value";
        series.dataFields.categoryX = "year";
        series.tooltipText = "[{categoryX}: bold]{valueY}[/]";
        series.columns.template.strokeWidth = 0;

        series.tooltip.pointerOrientation = "vertical";

        series.columns.template.column.cornerRadiusTopLeft = 10;
        series.columns.template.column.cornerRadiusTopRight = 10;
        series.columns.template.column.fillOpacity = 0.8;

        // on hover, make corner radiuses bigger
        let hoverState = series.columns.template.column.states.create("hover");
        hoverState.properties.cornerRadiusTopLeft = 0;
        hoverState.properties.cornerRadiusTopRight = 0;
        hoverState.properties.fillOpacity = 1;

        let bullet = series.bullets.push(new am4charts.LabelBullet())
        bullet.interactionsEnabled = false
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#000')

        series.columns.template.adapter.add("fill", function (fill, target) {
          return chart.colors.getIndex(target.dataItem.index);
        });

        chart.logo.disabled = true;
        // Cursor
        chart.cursor = new am4charts.XYCursor();
      })

      // ปริมารธุรกิจ ให้กู้
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_lend", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();
        let data = [];
        let net = "หน่วย : ล้านบาท"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].credit_val) {
            data.push({
              "year": res[i].year,
              "value": res[i].credit_val
            })

          }
        }

        chart.data = data;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจ ประเภทให้กู้";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจ ประเภทให้กู้";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        // Create axes
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;

        categoryAxis.fontSize = "11px"
        //categoryAxis.title.text = "ปีชุดข้อมูล"

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.minWidth = 50;
        valueAxis.fontSize = "11px"
        valueAxis.title.text = net

        // Create series
        let series = chart.series.push(new am4charts.ColumnSeries());
        series.sequencedInterpolation = true;
        series.dataFields.valueY = "value";
        series.dataFields.categoryX = "year";
        series.tooltipText = "[{categoryX}: bold]{valueY}[/]";
        series.columns.template.strokeWidth = 0;

        series.tooltip.pointerOrientation = "vertical";

        series.columns.template.column.cornerRadiusTopLeft = 10;
        series.columns.template.column.cornerRadiusTopRight = 10;
        series.columns.template.column.fillOpacity = 0.8;

        // on hover, make corner radiuses bigger
        let hoverState = series.columns.template.column.states.create("hover");
        hoverState.properties.cornerRadiusTopLeft = 0;
        hoverState.properties.cornerRadiusTopRight = 0;
        hoverState.properties.fillOpacity = 1;

        let bullet = series.bullets.push(new am4charts.LabelBullet())
        bullet.interactionsEnabled = false
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#000')

        series.columns.template.adapter.add("fill", function (fill, target) {
          return chart.colors.getIndex(target.dataItem.index);
        });

        chart.logo.disabled = true;
        // Cursor
        chart.cursor = new am4charts.XYCursor();
      })

      // ปริมารธุรกิจ จัดหาสินค้ามาจำหน่าย
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_products", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();
        let data = [];
        let net = "หน่วย : ล้านบาท"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].sale_val) {
            data.push({
              "year": res[i].year,
              "value": res[i].sale_val
            })

          }
        }

        chart.data = data;
        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจ ประเภทจัดหาสินค้ามาจำหน่าย";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจ ประเภทจัดหาสินค้ามาจำหน่าย";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        // Create axes
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;

        categoryAxis.fontSize = "11px"
        //categoryAxis.title.text = "ปีชุดข้อมูล"

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.minWidth = 50;
        valueAxis.fontSize = "11px"
        valueAxis.title.text = net

        // Create series
        let series = chart.series.push(new am4charts.ColumnSeries());
        series.sequencedInterpolation = true;
        series.dataFields.valueY = "value";
        series.dataFields.categoryX = "year";
        series.tooltipText = "[{categoryX}: bold]{valueY}[/]";
        series.columns.template.strokeWidth = 0;

        series.tooltip.pointerOrientation = "vertical";

        series.columns.template.column.cornerRadiusTopLeft = 10;
        series.columns.template.column.cornerRadiusTopRight = 10;
        series.columns.template.column.fillOpacity = 0.8;

        // on hover, make corner radiuses bigger
        let hoverState = series.columns.template.column.states.create("hover");
        hoverState.properties.cornerRadiusTopLeft = 0;
        hoverState.properties.cornerRadiusTopRight = 0;
        hoverState.properties.fillOpacity = 1;

        let bullet = series.bullets.push(new am4charts.LabelBullet())
        bullet.interactionsEnabled = false
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#000')

        series.columns.template.adapter.add("fill", function (fill, target) {
          return chart.colors.getIndex(target.dataItem.index);
        });

        chart.logo.disabled = true;
        // Cursor
        chart.cursor = new am4charts.XYCursor();
      })

      // ปริมารธุรกิจ รวบรวมผลผลิต
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_produce", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();
        let data = [];
        let net = "หน่วย : ล้านบาท"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].collect_val) {
            data.push({
              "year": res[i].year,
              "value": res[i].collect_val
            })

          }
        }

        chart.data = data;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจ ประเภทรวบรวมผลผลิต";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจ ประเภทรวบรวมผลผลิต";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        // Create axes
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;

        categoryAxis.fontSize = "11px"
        //categoryAxis.title.text = "ปีชุดข้อมูล"

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.minWidth = 50;
        valueAxis.fontSize = "11px"
        valueAxis.title.text = net

        // Create series
        let series = chart.series.push(new am4charts.ColumnSeries());
        series.sequencedInterpolation = true;
        series.dataFields.valueY = "value";
        series.dataFields.categoryX = "year";
        series.tooltipText = "[{categoryX}: bold]{valueY}[/]";
        series.columns.template.strokeWidth = 0;

        series.tooltip.pointerOrientation = "vertical";

        series.columns.template.column.cornerRadiusTopLeft = 10;
        series.columns.template.column.cornerRadiusTopRight = 10;
        series.columns.template.column.fillOpacity = 0.8;

        // on hover, make corner radiuses bigger
        let hoverState = series.columns.template.column.states.create("hover");
        hoverState.properties.cornerRadiusTopLeft = 0;
        hoverState.properties.cornerRadiusTopRight = 0;
        hoverState.properties.fillOpacity = 1;

        let bullet = series.bullets.push(new am4charts.LabelBullet())
        bullet.interactionsEnabled = false
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#000')

        series.columns.template.adapter.add("fill", function (fill, target) {
          return chart.colors.getIndex(target.dataItem.index);
        });

        chart.logo.disabled = true;
        // Cursor
        chart.cursor = new am4charts.XYCursor();
      })

      // ปริมารธุรกิจ แปรรูปผลผลิต
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_Processing", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();
        let data = [];
        let net = "หน่วย : ล้านบาท"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].transfrom_val) {
            data.push({
              "year": res[i].year,
              "value": res[i].transfrom_val
            })
          }
        }

        chart.data = data;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจ ประเภทแปรรูปผลผลิต";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจ ประเภทแปรรูปผลผลิต";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        // Create axes
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;

        categoryAxis.fontSize = "11px"
        //categoryAxis.title.text = "ปีชุดข้อมูล"

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.minWidth = 50;
        valueAxis.fontSize = "11px"
        valueAxis.title.text = net


        // Create series
        let series = chart.series.push(new am4charts.ColumnSeries());
        series.sequencedInterpolation = true;
        series.dataFields.valueY = "value";
        series.dataFields.categoryX = "year";
        series.tooltipText = "[{categoryX}: bold]{valueY}[/]";
        series.columns.template.strokeWidth = 0;

        series.tooltip.pointerOrientation = "vertical";

        series.columns.template.column.cornerRadiusTopLeft = 10;
        series.columns.template.column.cornerRadiusTopRight = 10;
        series.columns.template.column.fillOpacity = 0.8;

        // on hover, make corner radiuses bigger
        let hoverState = series.columns.template.column.states.create("hover");
        hoverState.properties.cornerRadiusTopLeft = 0;
        hoverState.properties.cornerRadiusTopRight = 0;
        hoverState.properties.fillOpacity = 1;

        let bullet = series.bullets.push(new am4charts.LabelBullet())
        bullet.interactionsEnabled = false
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#000')

        series.columns.template.adapter.add("fill", function (fill, target) {
          return chart.colors.getIndex(target.dataItem.index);
        });

        chart.logo.disabled = true;
        // Cursor
        chart.cursor = new am4charts.XYCursor();
      })

      // ปริมารธุรกิจ บรืการ
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_service", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();
        let data = [];
        let net = "หน่วย : ล้านบาท"

        for (let i = 0; i < res.length; i++) {
          if (res[i].service_val) {
            data.push({
              "year": res[i].year,
              "value": res[i].service_val
            })

          }
        }

        chart.data = data;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจ ประเภทบริการ";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจ ประเภทบริการ";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        // Create axes
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;

        categoryAxis.fontSize = "11px"
        //categoryAxis.title.text = "ปีชุดข้อมูล"

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.minWidth = 50;
        valueAxis.fontSize = "11px"
        valueAxis.title.text = net


        // Create series
        let series = chart.series.push(new am4charts.ColumnSeries());
        series.sequencedInterpolation = true;
        series.dataFields.valueY = "value";
        series.dataFields.categoryX = "year";
        series.tooltipText = "[{categoryX}: bold]{valueY}[/]";
        series.columns.template.strokeWidth = 0;

        series.tooltip.pointerOrientation = "vertical";

        series.columns.template.column.cornerRadiusTopLeft = 10;
        series.columns.template.column.cornerRadiusTopRight = 10;
        series.columns.template.column.fillOpacity = 0.8;

        // on hover, make corner radiuses bigger
        let hoverState = series.columns.template.column.states.create("hover");
        hoverState.properties.cornerRadiusTopLeft = 0;
        hoverState.properties.cornerRadiusTopRight = 0;
        hoverState.properties.fillOpacity = 1;

        let bullet = series.bullets.push(new am4charts.LabelBullet())
        bullet.interactionsEnabled = false
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#000')

        series.columns.template.adapter.add("fill", function (fill, target) {
          return chart.colors.getIndex(target.dataItem.index);
        });

        chart.logo.disabled = true;
        // Cursor
        chart.cursor = new am4charts.XYCursor();
      })
    })

  }

  Type1() {
    this.CoopServiceService.GetCoopBussinessType(this.OrgOrgId, this.PhakId, this.KhetId).subscribe(res => {
      res = callable.shiftYear(res, this.yearData);
      // ปริมาณธุรกิจ เกษตร ประเภทรับฝากเงิน
      this.zone.runOutsideAngular(() => {
        let chart = am4core.create("chartdiv_business_type1_deposit_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "1") {
            data.push({
              "year": res[i].year,
              "value": res[i].deposit_val
            })
          }
        }

        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจสหกรณ์การเกษตร ประเภทรับฝากเงิน";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจสหกรณ์การเกษตร ประเภทรับฝากเงิน";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

        chart.data = data;

      })

      // ปริมาณธุรกิจ เกษตร ประเภทให้กู้
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type1_credit_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "1") {
            data.push({
              "year": res[i].year,
              "value": res[i].credit_val
            })
          }
        }

        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจสหกรณ์การเกษตร ประเภทให้เงินกู้";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจสหกรณ์การเกษตร ประเภทให้เงินกู้";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

        chart.data = data;

      })

      // ปริมาณธุรกิจ เกษตร ประเภทจัดหา
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type1_sale_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "1") {
            data.push({
              "year": res[i].year,
              "value": res[i].sale_val
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;
        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจสหกรณ์การเกษตร ประเภทจัดหาสินค้ามาจำหน่าย";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจสหกรณ์การเกษตร ประเภทจัดหาสินค้ามาจำหน่าย";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // ปริมาณธุรกิจ เกษตร ประเภทรวบรวม
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type1_collect_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "1") {
            data.push({
              "year": res[i].year,
              "value": res[i].collect_val
            })

          }
        }
        chart.data = data;
        chart.logo.disabled = true;
        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจสหกรณ์การเกษตร ประเภทรวบรวมผลผลิต";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจสหกรณ์การเกษตร ประเภทรวบรวมผลผลิต";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // ปริมาณธุรกิจ เกษตร ประเภทแปรรูป
      this.zone.runOutsideAngular(() => {

        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type1_transfrom_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "1") {
            data.push({
              "year": res[i].year,
              "value": res[i].transfrom_val
            })
          }
        }

        chart.data = data;
        chart.logo.disabled = true;
        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจสหกรณ์การเกษตร ประเภทแปรรูปผลผลิต";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจสหกรณ์การเกษตร ประเภทแปรรูปผลผลิต";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // ปริมาณธุรกิจ เกษตร ประเภทบริการ
      this.zone.runOutsideAngular(() => {

        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type1_service_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "1") {
            data.push({
              "year": res[i].year,
              "value": res[i].service_val
            })
          }
        }

        chart.data = data;
        chart.logo.disabled = true;
        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจสหกรณ์การเกษตร ประเภทบริการ";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจสหกรณ์การเกษตร ประเภทบริการ";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })
    })
  }

  Type2() {
    this.CoopServiceService.GetCoopBussinessType(this.OrgOrgId, this.PhakId, this.KhetId).subscribe(res => {
      res = callable.shiftYear(res, this.yearData);
      // ปริมาณธุรกิจ ประมง ประเภทรับฝากเงิน
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type2_deposit_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "2") {
            data.push({
              "year": res[i].year,
              "value": res[i].deposit_val
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;
        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจสหกรณ์ประมง ประเภทรับฝากเงิน";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจสหกรณ์ประมง ประเภทรับฝากเงิน";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // ปริมาณธุรกิจ ประมง ประเภทให้กู้
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type2_credit_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "2") {
            data.push({
              "year": res[i].year,
              "value": res[i].credit_val
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;
        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจสหกรณ์ประมง ประเภทให้กู้";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจสหกรณ์ประมง ประเภทให้กู้";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // ปริมาณธุรกิจ ประมง ประเภทจัดหา
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type2_sale_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "2") {
            data.push({
              "year": res[i].year,
              "value": res[i].sale_val
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;
        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจสหกรณ์ประมง ประเภทจัดหาสินค้ามาจำหน่าย";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจสหกรณ์ประมง ประเภทจัดหาสินค้ามาจำหน่าย";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // ปริมาณธุรกิจ ประมง ประเภทรวบรวม
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type2_collect_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "2") {
            data.push({
              "year": res[i].year,
              "value": res[i].collect_val
            })
          }
        }

        chart.data = data;
        chart.logo.disabled = true;
        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจสหกรณ์ประมง ประเภทรวบรวมผลผลิต";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจสหกรณ์ประมง ประเภทรวบรวมผลผลิต";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // ปริมาณธุรกิจ ประมง ประเภทแปรรูป
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type2_transfrom_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "2") {
            data.push({
              "year": res[i].year,
              "value": res[i].transfrom_val
            })
          }
        }

        chart.data = data;
        chart.logo.disabled = true;
        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจสหกรณ์ประมง ประเภทแปรรูป";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจสหกรณ์ประมง ประเภทแปรรูป";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // ปริมาณธุรกิจ ประมง ประเภทบริการ
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type2_service_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "2") {
            data.push({
              "year": res[i].year,
              "value": res[i].service_val
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;
        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจสหกรณ์ประมง ประเภทบริการ";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจสหกรณ์ประมง ประเภทบริการ";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })
    })

  }

  Type3() {
    this.CoopServiceService.GetCoopBussinessType(this.OrgOrgId, this.PhakId, this.KhetId).subscribe(res => {
      res = callable.shiftYear(res, this.yearData);
      // ปริมาณธุรกิจ นิคม ประเภทรับฝากเงิน
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type3_deposit_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "3") {
            data.push({
              "year": res[i].year,
              "value": res[i].deposit_val
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;
        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจสหกรณ์นิคม ประเภทรับฝากเงิน";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจสหกรณ์นิคม ประเภทรับฝากเงิน";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // ปริมาณธุรกิจ นิคม ประเภทให้กู้
      this.zone.runOutsideAngular(() => {

        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type3_credit_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "3") {
            data.push({
              "year": res[i].year,
              "value": res[i].credit_val
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;
        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจสหกรณ์นิคม ประเภทให้กู้";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจสหกรณ์นิคม ประเภทให้กู้";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // ปริมาณธุรกิจ นิคม ประเภทจัดหา
      this.zone.runOutsideAngular(() => {

        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type3_sale_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "3") {
            data.push({
              "year": res[i].year,
              "value": res[i].sale_val
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;
        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจสหกรณ์นิคม ประเภทจัดหาสินค้ามาจำหน่าย";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจสหกรณ์นิคม ประเภทจัดหาสินค้ามาจำหน่าย";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // ปริมาณธุรกิจ นิคม ประเภทรวบรวม
      this.zone.runOutsideAngular(() => {

        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type3_collect_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "3") {
            data.push({
              "year": res[i].year,
              "value": res[i].collect_val
            })
          }
        }

        chart.data = data;
        chart.logo.disabled = true;
        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจสหกรณ์นิคม ประเภทรวบรวมผลผลิต";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจสหกรณ์นิคม ประเภทรวบรวมผลผลิต";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // ปริมาณธุรกิจ นิคม ประเภทแปรรูป
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type3_transfrom_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "3") {
            data.push({
              "year": res[i].year,
              "value": res[i].transfrom_val
            })
          }
        }

        chart.data = data;
        chart.logo.disabled = true;
        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจสหกรณ์นิคม ประเภทแปรรูป";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจสหกรณ์นิคม ประเภทแปรรูป";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // ปริมาณธุรกิจ นิคม ประเภทบริการ
      this.zone.runOutsideAngular(() => {

        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type3_service_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "3") {
            data.push({
              "year": res[i].year,
              "value": res[i].service_val
            })
          }
        }

        chart.data = data;
        chart.logo.disabled = true;
        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจสหกรณ์นิคม ประเภทบริการ";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจสหกรณ์นิคม ประเภทบริการ";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })
    })

  }

  Type4() {
    this.CoopServiceService.GetCoopBussinessType(this.OrgOrgId, this.PhakId, this.KhetId).subscribe(res => {
      res = callable.shiftYear(res, this.yearData);
      // ปริมาณธุรกิจ ออม ประเภทรับฝากเงิน
      this.zone.runOutsideAngular(() => {

        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type4_deposit_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "4") {
            data.push({
              "year": res[i].year,
              "value": res[i].deposit_val
            })
          }
        }

        chart.data = data;
        chart.logo.disabled = true;
        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจสหกรณ์ออม ประเภทรับฝากเงิน";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจสหกรณ์ออม ประเภทรับฝากเงิน";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // ปริมาณธุรกิจ ออม ประเภทให้กู้
      this.zone.runOutsideAngular(() => {

        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type4_credit_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "4") {
            data.push({
              "year": res[i].year,
              "value": res[i].credit_val
            })
          }
        }

        chart.data = data;
        chart.logo.disabled = true;
        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจสหกรณ์ออม ประเภทให้กู้";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจสหกรณ์ออม ประเภทให้กู้";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // ปริมาณธุรกิจ ออม ประเภทจัดหา
      this.zone.runOutsideAngular(() => {

        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type4_sale_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "4") {
            data.push({
              "year": res[i].year,
              "value": res[i].sale_val
            })
          }
        }

        chart.data = data;
        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจสหกรณ์ออม ประเภทจัดหาสินค้ามาจำหน่าย";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจสหกรณ์ออม ประเภทจัดหาสินค้ามาจำหน่าย";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // ปริมาณธุรกิจ ออม ประเภทรวบรวม
      this.zone.runOutsideAngular(() => {

        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type4_collect_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "4") {
            data.push({
              "year": res[i].year,
              "value": res[i].collect_val
            })
          }
        }

        chart.data = data;
        chart.logo.disabled = true;
        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจสหกรณ์ออม ประเภทรวบรวมผลผลิต";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจสหกรณ์ออม ประเภทรวบรวมผลผลิต";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // ปริมาณธุรกิจ ออม ประเภทแปรรูป
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type4_transfrom_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "4") {
            data.push({
              "year": res[i].year,
              "value": res[i].transfrom_val
            })
          }
        }

        chart.data = data;
        chart.logo.disabled = true;
        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจสหกรณ์ออม ประเภทแปรรูป";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจสหกรณ์ออม ประเภทแปรรูป";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // ปริมาณธุรกิจ ออม ประเภทบริการ
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type4_service_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "4") {
            data.push({
              "year": res[i].year,
              "value": res[i].service_val
            })
          }
        }

        chart.data = data;
        chart.logo.disabled = true;
        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจสหกรณ์ออม ประเภทบริการ";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจสหกรณ์ออม ประเภทบริการ";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })
    })
  }

  Type5() {
    this.CoopServiceService.GetCoopBussinessType(this.OrgOrgId, this.PhakId, this.KhetId).subscribe(res => {
      res = callable.shiftYear(res, this.yearData);
      // ปริมาณธุรกิจ ร้านค้า ประเภทรับฝากเงิน
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type5_deposit_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "5") {
            data.push({
              "year": res[i].year,
              "value": res[i].deposit_val
            })
          }
        }

        chart.data = data;
        chart.logo.disabled = true;
        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจสหกรณ์ร้านค้า ประเภทรับฝากเงิน";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจสหกรณ์ร้านค้า ประเภทรับฝากเงิน";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // ปริมาณธุรกิจ ร้านค้า ประเภทให้กู้
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type5_credit_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "5") {
            data.push({
              "year": res[i].year,
              "value": res[i].credit_val
            })
          }
        }

        chart.data = data;
        chart.logo.disabled = true;
        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจสหกรณ์ร้านค้า ประเภทให้กู้";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจสหกรณ์ร้านค้า ประเภทให้กู้";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // ปริมาณธุรกิจ ร้านค้า ประเภทจัดหา
      this.zone.runOutsideAngular(() => {

        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type5_sale_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "5") {
            data.push({
              "year": res[i].year,
              "value": res[i].sale_val
            })
          }
        }

        chart.data = data;
        chart.logo.disabled = true;
        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจสหกรณ์ร้านค้า ประเภทจัดหาสินค้ามาจำหน่าย";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจสหกรณ์ร้านค้า ประเภทจัดหาสินค้ามาจำหน่าย";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // ปริมาณธุรกิจ ร้านค้า ประเภทรวบรวม
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type5_collect_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "5") {
            data.push({
              "year": res[i].year,
              "value": res[i].collect_val
            })
          }
        }

        chart.data = data;
        chart.logo.disabled = true;
        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจสหกรณ์ร้านค้า ประเภทรวบรวมผลผลิต";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจสหกรณ์ร้านค้า ประเภทรวบรวมผลผลิต";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // ปริมาณธุรกิจ ร้าน้คา ประเภทแปรรูป
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type5_transfrom_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "5") {
            data.push({
              "year": res[i].year,
              "value": res[i].transfrom_val
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;
        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจสหกรณ์ร้านค้า ประเภทแปรรูป";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจสหกรณ์ร้านค้า ประเภทแปรรูป";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // ปริมาณธุรกิจ ร้านค้า ประเภทบริการ
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type5_service_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "5") {
            data.push({
              "year": res[i].year,
              "value": res[i].service_val
            })
          }
        }

        chart.data = data;
        chart.logo.disabled = true;
        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจสหกรณ์ร้านค้า ประเภทบริการ";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจสหกรณ์ร้านค้า ประเภทบริการ";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })
    })
  }

  Type6() {
    this.CoopServiceService.GetCoopBussinessType(this.OrgOrgId, this.PhakId, this.KhetId).subscribe(res => {
      res = callable.shiftYear(res, this.yearData);
      // ปริมาณธุรกิจ บริการ ประเภทรับฝากเงิน
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type6_deposit_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "6") {
            data.push({
              "year": res[i].year,
              "value": res[i].deposit_val
            })
          }
        }

        chart.data = data;
        chart.logo.disabled = true;
        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจสหกรณ์บริการ ประเภทรับฝากเงิน";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจสหกรณ์บริการ ประเภทรับฝากเงิน";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // ปริมาณธุรกิจ บริการ ประเภทให้กู้
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type6_credit_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "6") {
            data.push({
              "year": res[i].year,
              "value": res[i].credit_val
            })
          }
        }

        chart.data = data;
        chart.logo.disabled = true;
        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจสหกรณ์บริการ ประเภทให้กู้";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจสหกรณ์บริการ ประเภทให้กู้";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // ปริมาณธุรกิจ บริการ ประเภทจัดหา
      this.zone.runOutsideAngular(() => {

        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type6_sale_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "6") {
            data.push({
              "year": res[i].year,
              "value": res[i].sale_val
            })
          }
        }

        chart.data = data;
        chart.logo.disabled = true;
        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจสหกรณ์บริการ ประเภทจัดหาสินค้ามาจำหน่าย";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจสหกรณ์บริการ ประเภทจัดหาสินค้ามาจำหน่าย";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // ปริมาณธุรกิจ บริการ ประเภทรวบรวม
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type6_collect_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "6") {
            data.push({
              "year": res[i].year,
              "value": res[i].collect_val
            })
          }
        }

        chart.data = data;
        chart.logo.disabled = true;
        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจสหกรณ์บริการ ประเภทรวบรวม";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจสหกรณ์บริการ ประเภทรวบรวม";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // ปริมาณธุรกิจ บริการ ประเภทแปรรูป
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type6_transfrom_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "6") {
            data.push({
              "year": res[i].year,
              "value": res[i].transfrom_val
            })
          }
        }
        chart.data = data;
        chart.logo.disabled = true;
        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจสหกรณ์บริการ ประเภทแปรรูป";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจสหกรณ์บริการ ประเภทแปรรูป";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // ปริมาณธุรกิจ บริการ ประเภทบริการ
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type6_service_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "6") {
            data.push({
              "year": res[i].year,
              "value": res[i].service_val
            })
          }
        }

        chart.data = data;
        chart.logo.disabled = true;
        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจสหกรณ์บริการ ประเภทบริการ";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจสหกรณ์บริการ ประเภทบริการ";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })
    })
  }

  Type7() {
    this.CoopServiceService.GetCoopBussinessType(this.OrgOrgId, this.PhakId, this.KhetId).subscribe(res => {
      res = callable.shiftYear(res, this.yearData);
      // ปริมาณธุรกิจ เครดิต ประเภทรับฝากเงิน
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type7_deposit_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "7") {
            data.push({
              "year": res[i].year,
              "value": res[i].deposit_val
            })
          }
        }

        chart.data = data;
        chart.logo.disabled = true;
        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจสหกรณ์เครดิต ประเภทรับฝากเงิน";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจสหกรณ์เครดิต ประเภทรับฝากเงิน";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // ปริมาณธุรกิจ เครดิต ประเภทให้กู้
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type7_credit_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "7") {
            data.push({
              "year": res[i].year,
              "value": res[i].credit_val
            })
          }
        }

        chart.data = data;
        chart.logo.disabled = true;
        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจสหกรณ์เครดิต ประเภทให้กู้";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจสหกรณ์เครดิต ประเภทให้กู้";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // ปริมาณธุรกิจ เครดิต ประเภทจัดหา
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type7_sale_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "7") {

            data.push({
              "year": res[i].year,
              "value": res[i].sale_val
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;
        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจสหกรณ์เครดิต ประเภทจัดหาสินค้ามาจำหน่าย";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจสหกรณ์เครดิต ประเภทจัดหาสินค้ามาจำหน่าย";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // ปริมาณธุรกิจ เครดิต ประเภทรวบรวม
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type7_collect_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "7") {
            data.push({
              "year": res[i].year,
              "value": res[i].collect_val
            })
          }
        }

        chart.data = data;
        chart.logo.disabled = true;
        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจสหกรณ์เครดิต ประเภทรวบรวม";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจสหกรณ์เครดิต ประเภทรวบรวม";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // ปริมาณธุรกิจ เครดิต ประเภทแปรรูป
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type7_transfrom_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "7") {
            data.push({
              "year": res[i].year,
              "value": res[i].transfrom_val
            })
          }
        }

        chart.data = data;
        chart.logo.disabled = true;
        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจสหกรณ์เครดิต ประเภทแปรรูป";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจสหกรณ์เครดิต ประเภทแปรรูป";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // ปริมาณธุรกิจ เครดิต ประเภทบริการ
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_type7_service_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : ล้านบาท"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "7") {
            data.push({
              "year": res[i].year,
              "value": res[i].service_val
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;
        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจสหกรณ์เครดิต ประเภทบริการ";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจสหกรณ์เครดิต ประเภทบริการ";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "ปริมาณธุรกิจ";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })
    })
  }

  asset1info() {
    this.CoopServiceService.GetCoopFinanceType(this.OrgOrgId, this.PhakId, this.KhetId).subscribe(res => {
      res = callable.shiftYear(res, this.yearData);
      // สินทรัพย์ของสหกรณ์ ประเภทสหกรณ์1
      this.zone.runOutsideAngular(() => {

        let chart = am4core.create("chartdiv_asset_type1_info", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = [];
        let net = "หน่วย : ล้านบาท"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "1") {
            data.push({
              "year": res[i].year,
              "value": res[i].net_asset
            })
          }
        }

        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "สินทรัพย์ของสหกรณ์ ประเภทสหกรณ์การเกษตร";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "สินทรัพย์ของสหกรณ์ ประเภทสหกรณ์การเกษตร";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "สินทรัพย์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

        chart.data = data;

      })

      // สินทรัพย์ของสหกรณ์ ประเภทสหกรณ์2
      this.zone.runOutsideAngular(() => {

        let chart = am4core.create("chartdiv_asset_type2_info", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = [];
        let net = "หน่วย : ล้านบาท"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "2") {
            data.push({
              "year": res[i].year,
              "value": res[i].net_asset
            })
          }
        }

        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "สินทรัพย์ของสหกรณ์ ประเภทสหกรณ์ประมง";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "สินทรัพย์ของสหกรณ์ ประเภทสหกรณ์ประมง";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "สินทรัพย์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

        chart.data = data;
      })

      // สินทรัพย์ของสหกรณ์ ประเภทสหกรณ์3
      this.zone.runOutsideAngular(() => {

        let chart = am4core.create("chartdiv_asset_type3_info", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = [];
        let net = "หน่วย : ล้านบาท"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "3") {
            data.push({
              "year": res[i].year,
              "value": res[i].net_asset
            })
          }
        }

        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "สินทรัพย์ของสหกรณ์ ประเภทสหกรณ์นิคม";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "สินทรัพย์ของสหกรณ์ ประเภทสหกรณ์นิคม";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "สินทรัพย์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

        chart.data = data;

      })

      // สินทรัพย์ของสหกรณ์ ประเภทสหกรณ์4
      this.zone.runOutsideAngular(() => {

        let chart = am4core.create("chartdiv_asset_type4_info", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = [];
        let net = "หน่วย : ล้านบาท"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "4") {
            data.push({
              "year": res[i].year,
              "value": res[i].net_asset
            })
          }
        }

        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "สินทรัพย์ของสหกรณ์ ประเภทสหกรณ์ออมทรัพย์";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "สินทรัพย์ของสหกรณ์ ประเภทสหกรณ์ออมทรัพย์";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "สินทรัพย์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

        chart.data = data;

      })

      // สินทรัพย์ของสหกรณ์ ประเภทสหกรณ์5
      this.zone.runOutsideAngular(() => {

        let chart = am4core.create("chartdiv_asset_type5_info", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = [];
        let net = "หน่วย : ล้านบาท"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "5") {
            data.push({
              "year": res[i].year,
              "value": res[i].net_asset
            })
          }
        }

        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "สินทรัพย์ของสหกรณ์ ประเภทสหกรณ์ร้านค้า";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "สินทรัพย์ของสหกรณ์ ประเภทสหกรณ์ร้านค้า";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "สินทรัพย์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

        chart.data = data;

      })

      // สินทรัพย์ของสหกรณ์ ประเภทสหกรณ์6
      this.zone.runOutsideAngular(() => {

        let chart = am4core.create("chartdiv_asset_type6_info", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = [];
        let net = "หน่วย : ล้านบาท"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "6") {
            data.push({
              "year": res[i].year,
              "value": res[i].net_asset
            })
          }
        }

        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "สินทรัพย์ของสหกรณ์ ประเภทสหกรณ์บริการ";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "สินทรัพย์ของสหกรณ์ ประเภทสหกรณ์บริการ";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "สินทรัพย์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

        chart.data = data;

      })

      // สินทรัพย์ของสหกรณ์ ประเภทสหกรณ์7
      this.zone.runOutsideAngular(() => {

        let chart = am4core.create("chartdiv_asset_type7_info", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = [];
        let net = "หน่วย : ล้านบาท"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "7") {
            data.push({
              "year": res[i].year,
              "value": res[i].net_asset
            })

          }
        }

        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "สินทรัพย์ของสหกรณ์ ประเภทสหกรณ์เครดิตยูเนี่ยน";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "สินทรัพย์ของสหกรณ์ ประเภทสหกรณ์เครดิตยูเนี่ยน";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "สินทรัพย์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

        chart.data = data;

      })
    })
  }

  asset2info() {
    this.CoopServiceService.GetCoopFinanceType(this.OrgOrgId, this.PhakId, this.KhetId).subscribe(res => {
      res = callable.shiftYear(res, this.yearData);
      //หนี้สินของสหกรณ์ ประเภทสหกรณ์1
      this.zone.runOutsideAngular(() => {
        let chart = am4core.create("chartdiv_debt_type1_info", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = [];
        let net = "หน่วย : ล้านบาท"
        // Add data
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "1") {
            data.push({
              "year": res[i].year,
              "value": res[i].liabilities
            })
          }
        }

        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "หนี้สินของสหกรณ์ ประเภทสหกรณ์การเกษตร";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "หนี้สินของสหกรณ์ ประเภทสหกรณ์การเกษตร";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "สินทรัพย์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

        chart.data = data;

      })

      // หนี้สินของสหกรณ์ ประเภทสหกรณ์2
      this.zone.runOutsideAngular(() => {

        let chart = am4core.create("chartdiv_debt_type2_info", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = [];
        let net = "หน่วย : ล้านบาท"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "2") {
            data.push({
              "year": res[i].year,
              "value": res[i].liabilities
            })
          }
        }

        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "หนี้สินของสหกรณ์ ประเภทสหกรณ์ประมง";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "หนี้สินของสหกรณ์ ประเภทสหกรณ์ประมง";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "สินทรัพย์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

        chart.data = data;

      })

      // หนี้สินของสหกรณ์ ประเภทสหกรณ์3
      this.zone.runOutsideAngular(() => {

        let chart = am4core.create("chartdiv_debt_type3_info", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = [];
        let net = "หน่วย : ล้านบาท"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "3") {
            data.push({
              "year": res[i].year,
              "value": res[i].liabilities
            })
          }
        }

        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "หนี้สินของสหกรณ์ ประเภทสหกรณ์นิคม";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "หนี้สินของสหกรณ์ ประเภทสหกรณ์นิคม";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "สินทรัพย์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

        chart.data = data;

      })

      // หนี้สินของสหกรณ์ ประเภทสหกรณ์4
      this.zone.runOutsideAngular(() => {

        let chart = am4core.create("chartdiv_debt_type4_info", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = [];
        let net = "หน่วย : ล้านบาท"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "4") {
            data.push({
              "year": res[i].year,
              "value": res[i].liabilities
            })
          }
        }

        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "หนี้สินของสหกรณ์ ประเภทสหกรณ์ออมทรัพย์";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "หนี้สินของสหกรณ์ ประเภทสหกรณ์ออมทรัพย์";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "สินทรัพย์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

        chart.data = data;

      })

      // หนี้สินของสหกรณ์ ประเภทสหกรณ์5
      this.zone.runOutsideAngular(() => {

        let chart = am4core.create("chartdiv_debt_type5_info", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = [];
        let net = "หน่วย : ล้านบาท"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "5") {
            data.push({
              "year": res[i].year,
              "value": res[i].liabilities
            })
          }
        }

        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "หนี้สินของสหกรณ์ ประเภทสหกรณ์ร้านค้า";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "หนี้สินของสหกรณ์ ประเภทสหกรณ์ร้านค้า";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "สินทรัพย์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

        chart.data = data;

      })

      // หนี้สินของสหกรณ์ ประเภทสหกรณ์6
      this.zone.runOutsideAngular(() => {

        let chart = am4core.create("chartdiv_debt_type6_info", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = [];
        let net = "หน่วย : ล้านบาท"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "6") {
            data.push({
              "year": res[i].year,
              "value": res[i].liabilities
            })
          }
        }

        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "หนี้สินของสหกรณ์ ประเภทสหกรณ์บริการ";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "หนี้สินของสหกรณ์ ประเภทสหกรณ์บริการ";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "สินทรัพย์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

        chart.data = data;

      })

      // หนี้สินของสหกรณ์ ประเภทสหกรณ์7
      this.zone.runOutsideAngular(() => {

        let chart = am4core.create("chartdiv_debt_type7_info", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = [];
        let net = "หน่วย : ล้านบาท"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "7") {
            data.push({
              "year": res[i].year,
              "value": res[i].liabilities
            })
          }
        }

        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "หนี้สินของสหกรณ์ ประเภทสหกรณ์เครดิตยูเนี่ยน";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "หนี้สินของสหกรณ์ ประเภทสหกรณ์เครดิตยูเนี่ยน";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "สินทรัพย์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

        chart.data = data;

      })
    })
  }

  asset3info() {
    this.CoopServiceService.GetCoopFinanceType(this.OrgOrgId, this.PhakId, this.KhetId).subscribe(res => {
      res = callable.shiftYear(res, this.yearData);
      //ทุนของสหกรณ์ ประเภทสหกรณ์1
      this.zone.runOutsideAngular(() => {

        let chart = am4core.create("chartdiv_Capital_type1_info", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = [];
        let net = "หน่วย : ล้านบาท"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "1") {
            data.push({
              "year": res[i].year,
              "value": res[i].coop_capital
            })
          }
        }

        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ทุนของสหกรณ์ ประเภทสหกรณ์การเกษตร";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ทุนของสหกรณ์ ประเภทสหกรณ์การเกษตร";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "สินทรัพย์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

        chart.data = data;

      })

      // ทุนของสหกรณ์ ประเภทสหกรณ์2
      this.zone.runOutsideAngular(() => {

        let chart = am4core.create("chartdiv_Capital_type2_info", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = [];
        let net = "หน่วย : ล้านบาท"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "2") {
            data.push({
              "year": res[i].year,
              "value": res[i].coop_capital
            })
          }
        }

        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ทุนของสหกรณ์ ประเภทสหกรณ์ประมง";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ทุนของสหกรณ์ ประเภทสหกรณ์ประมง";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "สินทรัพย์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

        chart.data = data;

      })

      // ทุนของสหกรณ์ ประเภทสหกรณ์3
      this.zone.runOutsideAngular(() => {

        let chart = am4core.create("chartdiv_Capital_type3_info", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = [];
        let net = "หน่วย : ล้านบาท"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "3") {
            data.push({
              "year": res[i].year,
              "value": res[i].coop_capital
            })
          }
        }

        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ทุนของสหกรณ์ ประเภทสหกรณ์นิคม";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ทุนของสหกรณ์ ประเภทสหกรณ์นิคม";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "สินทรัพย์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

        chart.data = data;

      })

      // ทุนของสหกรณ์ ประเภทสหกรณ์4
      this.zone.runOutsideAngular(() => {

        let chart = am4core.create("chartdiv_Capital_type4_info", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = [];
        let net = "หน่วย : ล้านบาท"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "4") {
            data.push({
              "year": res[i].year,
              "value": res[i].coop_capital
            })
          }
        }

        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ทุนของสหกรณ์ ประเภทสหกรณ์ออมทรัพย์";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ทุนของสหกรณ์ ประเภทสหกรณ์ออมทรัพย์";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "สินทรัพย์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

        chart.data = data;

      })

      // ทุนของสหกรณ์ ประเภทสหกรณ์5
      this.zone.runOutsideAngular(() => {

        let chart = am4core.create("chartdiv_Capital_type5_info", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = [];
        let net = "หน่วย : ล้านบาท"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "5") {
            data.push({
              "year": res[i].year,
              "value": res[i].coop_capital
            })
          }
        }

        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ทุนของสหกรณ์ ประเภทสหกรณ์ร้านค้า";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ทุนของสหกรณ์ ประเภทสหกรณ์ร้านค้า";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "สินทรัพย์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

        chart.data = data;

      })

      // ทุนของสหกรณ์ ประเภทสหกรณ์6
      this.zone.runOutsideAngular(() => {
        let chart = am4core.create("chartdiv_Capital_type6_info", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = [];
        let net = "หน่วย : ล้านบาท"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "6") {
            data.push({
              "year": res[i].year,
              "value": res[i].coop_capital
            })
          }
        }

        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ทุนของสหกรณ์ ประเภทสหกรณ์บริการ";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ทุนของสหกรณ์ ประเภทสหกรณ์บริการ";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "สินทรัพย์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

        chart.data = data;
      })

      // ทุนของสหกรณ์ ประเภทสหกรณ์7
      this.zone.runOutsideAngular(() => {

        let chart = am4core.create("chartdiv_Capital_type7_info", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = [];
        let net = "หน่วย : ล้านบาท"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "7") {
            data.push({
              "year": res[i].year,
              "value": res[i].coop_capital
            })
          }
        }

        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ทุนของสหกรณ์ ประเภทสหกรณ์เครดิตยูเนี่ยน";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ทุนของสหกรณ์ ประเภทสหกรณ์เครดิตยูเนี่ยน";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "สินทรัพย์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

        chart.data = data;

      })
    })
  }

  asset4info() {
    this.CoopServiceService.GetCoopFinanceType(this.OrgOrgId, this.PhakId, this.KhetId).subscribe(res => {
      res = callable.shiftYear(res, this.yearData);
      //กำไรของสหกรณ์ ประเภทสหกรณ์1
      this.zone.runOutsideAngular(() => {

        let chart = am4core.create("chartdiv_profit_type1_info", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = [];
        let net = "หน่วย : ล้านบาท"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "1") {
            data.push({
              "year": res[i].year,
              "value": res[i].net_profit
            })
          }
        }

        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "กำไร(ขาดทุน)สหกรณ ประเภทสหกรณ์การเกษตร";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "กำไร(ขาดทุน)สหกรณ ประเภทสหกรณ์การเกษตร";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "สินทรัพย์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

        chart.data = data;

      })

      // กำไรของสหกรณ์ ประเภทสหกรณ์2
      this.zone.runOutsideAngular(() => {

        let chart = am4core.create("chartdiv_profit_type2_info", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = [];
        let net = "หน่วย : ล้านบาท"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "2") {
            data.push({
              "year": res[i].year,
              "value": res[i].net_profit
            })
          }
        }

        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "กำไร(ขาดทุน)สหกรณ ประเภทสหกรณ์ประมง";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "กำไร(ขาดทุน)สหกรณ ประเภทสหกรณ์ประมง";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "สินทรัพย์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

        chart.data = data;

      })

      // กำไรของสหกรณ์ ประเภทสหกรณ์3
      this.zone.runOutsideAngular(() => {

        let chart = am4core.create("chartdiv_profit_type3_info", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = [];
        let net = "หน่วย : ล้านบาท"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "3") {
            data.push({
              "year": res[i].year,
              "value": res[i].net_profit
            })
          }
        }

        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "กำไร(ขาดทุน)สหกรณ ประเภทสหกรณ์นิคม";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "กำไร(ขาดทุน)สหกรณ ประเภทสหกรณ์นิคม";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "สินทรัพย์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

        chart.data = data;

      })

      // กำไรของสหกรณ์ ประเภทสหกรณ์4
      this.zone.runOutsideAngular(() => {

        let chart = am4core.create("chartdiv_profit_type4_info", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = [];
        let net = "หน่วย : ล้านบาท"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "4") {
            data.push({
              "year": res[i].year,
              "value": res[i].net_profit
            })
          }
        }

        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "กำไร(ขาดทุน)สหกรณ ประเภทสหกรณ์ออมทรัพย์";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "กำไร(ขาดทุน)สหกรณ ประเภทสหกรณ์ออมทรัพย์";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "สินทรัพย์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

        chart.data = data;

      })

      // กำไรของสหกรณ์ ประเภทสหกรณ์5
      this.zone.runOutsideAngular(() => {

        let chart = am4core.create("chartdiv_profit_type5_info", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = [];
        let net = "หน่วย : ล้านบาท"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "5") {
            data.push({
              "year": res[i].year,
              "value": res[i].net_profit
            })
          }
        }

        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "กำไร(ขาดทุน)สหกรณ ประเภทสหกรณ์ร้านค้า";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "กำไร(ขาดทุน)สหกรณ ประเภทสหกรณ์ร้านค้า";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "สินทรัพย์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

        chart.data = data;

      })

      // กำไรของสหกรณ์ ประเภทสหกรณ์6
      this.zone.runOutsideAngular(() => {

        let chart = am4core.create("chartdiv_profit_type6_info", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = [];
        let net = "หน่วย : ล้านบาท"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "6") {
            data.push({
              "year": res[i].year,
              "value": res[i].net_profit
            })
          }
        }

        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "กำไร(ขาดทุน)สหกรณ ประเภทสหกรณ์บริการ";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "กำไร(ขาดทุน)สหกรณ ประเภทสหกรณ์บริการ";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "สินทรัพย์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

        chart.data = data;

      })

      // กำไรของสหกรณ์ ประเภทสหกรณ์7
      this.zone.runOutsideAngular(() => {
        let chart = am4core.create("chartdiv_profit_type7_info", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = [];
        let net = "หน่วย : ล้านบาท"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "7") {
            data.push({
              "year": res[i].year,
              "value": res[i].net_profit
            })
          }
        }

        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "กำไร(ขาดทุน)สหกรณ ประเภทสหกรณ์เครดิตยูเนี่ยน";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "กำไร(ขาดทุน)สหกรณ ประเภทสหกรณ์เครดิตยูเนี่ยน";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "สินทรัพย์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

        chart.data = data;

      })
    })
  }

  Participation() {
    this.CoopServiceService.GetCoopProfileBussiness(this.OrgOrgId, this.PhakId, this.KhetId).subscribe(res => {
      res = callable.shiftYear(res, this.yearData);
      // การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทรับฝากเงิน
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_deposit_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        for (let i = 0; i < res.length; i++) {
          if (res[i].sum_deposit) {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_deposit
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทรับฝากเงิน";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทรับฝากเงิน";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกสหกรณ์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทให้เงินกู้
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_credit_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].sum_credit) {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_credit
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทให้เงินกู้";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทให้เงินกู้";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกสหกรณ์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทจัดหาสินค้ามาจำหน่าย
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_sale_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].sum_sale) {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_sale
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทจัดหาสินค้ามาจำหน่าย";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทจัดหาสินค้ามาจำหน่าย";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกสหกรณ์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทรวบรวมผลผลิต
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_collect_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].sum_good) {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_good
            })

          }
        }


        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทรวบรวมผลผลิต";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทรวบรวมผลผลิต";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกสหกรณ์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทแปรรูปผลผลิต
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_transfrom_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].sum_marketing) {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_marketing
            })

          }
        }
        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทแปรรูปผลผลิต";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทแปรรูปผลผลิต";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกสหกรณ์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทบริการ
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_service_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].sum_service) {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_service
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทบริการ";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทบริการ";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกสหกรณ์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทอื่น ๆ
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_other_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].sum_other) {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_other
            })

          }
        }
        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทอื่น ๆ";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทอื่น ๆ";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกสหกรณ์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })
    })
  }

  Participation1() {
    this.CoopServiceService.GetCoopProfileBussinessType(this.OrgOrgId, this.PhakId, this.KhetId).subscribe(res => {
      res = callable.shiftYear(res, this.yearData);
      // การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทรับฝากเงิน
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type1_deposit_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "1") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_deposit
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทรับฝากเงิน";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทรับฝากเงิน";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกสหกรณ์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทให้เงินกู้
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type1_credit_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "1") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_credit
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทให้เงินกู้";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทให้เงินกู้";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกสหกรณ์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทจัดหาสินค้ามาจำหน่าย
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type1_sale_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "1") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_sale
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทจัดหาสินค้ามาจำหน่าย";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทจัดหาสินค้ามาจำหน่าย";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกสหกรณ์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทรวบรวมผลผลิต
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type1_collect_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "1") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_good
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทรวบรวมผลผลิต";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทรวบรวมผลผลิต";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกสหกรณ์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทแปรรูปผลผลิต
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type1_transfrom_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "1") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_marketing
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทแปรรูปผลผลิต";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทแปรรูปผลผลิต";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกสหกรณ์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทบริการ
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type1_service_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "1") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_service
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทบริการ";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทบริการ";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกสหกรณ์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทอื่น ๆ
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type1_other_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "1") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_other
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทอื่น ๆ";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทอื่น ๆ";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกสหกรณ์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })
    })
  }

  Participation2() {
    this.CoopServiceService.GetCoopProfileBussinessType(this.OrgOrgId, this.PhakId, this.KhetId).subscribe(res => {
      res = callable.shiftYear(res, this.yearData);
      // การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทรับฝากเงิน
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type2_deposit_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "2") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_deposit
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทรับฝากเงิน";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทรับฝากเงิน";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกสหกรณ์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทให้เงินกู้
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type2_credit_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "2") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_credit
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทให้เงินกู้";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทให้เงินกู้";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกสหกรณ์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทจัดหาสินค้ามาจำหน่าย
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type2_sale_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "2") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_sale
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทจัดหาสินค้ามาจำหน่าย";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทจัดหาสินค้ามาจำหน่าย";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกสหกรณ์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทรวบรวมผลผลิต
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type2_collect_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "2") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_good
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทรวบรวมผลผลิต";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทรวบรวมผลผลิต";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกสหกรณ์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทแปรรูปผลผลิต
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type2_transfrom_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "2") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_marketing
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทแปรรูปผลผลิต";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทแปรรูปผลผลิต";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกสหกรณ์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทบริการ
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type2_service_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "2") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_service
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทบริการ";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทบริการ";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกสหกรณ์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทอื่น ๆ
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type2_other_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "2") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_other
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทอื่น ๆ";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทอื่น ๆ";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกสหกรณ์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })
    })
  }

  Participation3() {
    this.CoopServiceService.GetCoopProfileBussinessType(this.OrgOrgId, this.PhakId, this.KhetId).subscribe(res => {
      res = callable.shiftYear(res, this.yearData);
      // การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทรับฝากเงิน
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type3_deposit_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "3") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_deposit
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทรับฝากเงิน";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทรับฝากเงิน";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกสหกรณ์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทให้เงินกู้
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type3_credit_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "3") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_credit
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทให้เงินกู้";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทให้เงินกู้";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกสหกรณ์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทจัดหาสินค้ามาจำหน่าย
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type3_sale_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "3") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_sale
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทจัดหาสินค้ามาจำหน่าย";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทจัดหาสินค้ามาจำหน่าย";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกสหกรณ์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทรวบรวมผลผลิต
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type3_collect_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "3") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_good
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทรวบรวมผลผลิต";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทรวบรวมผลผลิต";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกสหกรณ์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทแปรรูปผลผลิต
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type3_transfrom_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "3") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_marketing
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทแปรรูปผลผลิต";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทแปรรูปผลผลิต";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกสหกรณ์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทบริการ
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type3_service_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "3") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_service
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทบริการ";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทบริการ";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกสหกรณ์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทอื่น ๆ
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type3_other_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "3") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_other
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทอื่น ๆ";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทอื่น ๆ";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกสหกรณ์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })
    })
  }

  Participation4() {
    this.CoopServiceService.GetCoopProfileBussinessType(this.OrgOrgId, this.PhakId, this.KhetId).subscribe(res => {
      res = callable.shiftYear(res, this.yearData);
      // การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทรับฝากเงิน
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type4_deposit_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "4") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_deposit
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทรับฝากเงิน";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทรับฝากเงิน";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกสหกรณ์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทให้เงินกู้
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type4_credit_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "4") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_credit
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทให้เงินกู้";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทให้เงินกู้";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกสหกรณ์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทจัดหาสินค้ามาจำหน่าย
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type4_sale_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "4") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_sale
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทจัดหาสินค้ามาจำหน่าย";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทจัดหาสินค้ามาจำหน่าย";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกสหกรณ์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทรวบรวมผลผลิต
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type4_collect_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "4") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_good
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทรวบรวมผลผลิต";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทรวบรวมผลผลิต";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกสหกรณ์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทแปรรูปผลผลิต
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type4_transfrom_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "4") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_marketing
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทแปรรูปผลผลิต";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทแปรรูปผลผลิต";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกสหกรณ์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทบริการ
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type4_service_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "4") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_service
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทบริการ";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทบริการ";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกสหกรณ์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทอื่น ๆ
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type4_other_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "4") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_other
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทอื่น ๆ";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทอื่น ๆ";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกสหกรณ์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })
    })
  }

  Participation5() {
    this.CoopServiceService.GetCoopProfileBussinessType(this.OrgOrgId, this.PhakId, this.KhetId).subscribe(res => {
      res = callable.shiftYear(res, this.yearData);
      // การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทรับฝากเงิน
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type5_deposit_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "5") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_deposit
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทรับฝากเงิน";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทรับฝากเงิน";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกสหกรณ์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทให้เงินกู้
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type5_credit_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "5") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_credit
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทให้เงินกู้";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทให้เงินกู้";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกสหกรณ์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทจัดหาสินค้ามาจำหน่าย
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type5_sale_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "5") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_sale
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทจัดหาสินค้ามาจำหน่าย";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทจัดหาสินค้ามาจำหน่าย";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกสหกรณ์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทรวบรวมผลผลิต
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type5_collect_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "5") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_good
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทรวบรวมผลผลิต";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทรวบรวมผลผลิต";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกสหกรณ์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทแปรรูปผลผลิต
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type5_transfrom_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "5") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_marketing
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทแปรรูปผลผลิต";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทแปรรูปผลผลิต";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกสหกรณ์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทบริการ
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type5_service_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "5") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_service
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทบริการ";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทบริการ";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกสหกรณ์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทอื่น ๆ
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type5_other_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "5") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_other
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทอื่น ๆ";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทอื่น ๆ";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกสหกรณ์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })
    })
  }

  Participation6() {
    this.CoopServiceService.GetCoopProfileBussinessType(this.OrgOrgId, this.PhakId, this.KhetId).subscribe(res => {
      res = callable.shiftYear(res, this.yearData);
      // การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทรับฝากเงิน
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type6_deposit_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "6") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_deposit
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทรับฝากเงิน";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทรับฝากเงิน";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกสหกรณ์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทให้เงินกู้
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type6_credit_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "6") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_credit
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทให้เงินกู้";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทให้เงินกู้";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกสหกรณ์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทจัดหาสินค้ามาจำหน่าย
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type6_sale_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "6") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_sale
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทจัดหาสินค้ามาจำหน่าย";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทจัดหาสินค้ามาจำหน่าย";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกสหกรณ์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทรวบรวมผลผลิต
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type6_collect_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "6") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_good
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทรวบรวมผลผลิต";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทรวบรวมผลผลิต";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกสหกรณ์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทแปรรูปผลผลิต
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type6_transfrom_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "6") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_marketing
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทแปรรูปผลผลิต";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทแปรรูปผลผลิต";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกสหกรณ์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทบริการ
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type6_service_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "6") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_service
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทบริการ";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทบริการ";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกสหกรณ์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทอื่น ๆ
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type6_other_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "6") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_other
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทอื่น ๆ";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทอื่น ๆ";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกสหกรณ์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })
    })
  }

  Participation7() {
    this.CoopServiceService.GetCoopProfileBussinessType(this.OrgOrgId, this.PhakId, this.KhetId).subscribe(res => {
      res = callable.shiftYear(res, this.yearData);
      // การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทรับฝากเงิน
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type7_deposit_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "7") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_deposit
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทรับฝากเงิน";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทรับฝากเงิน";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกสหกรณ์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทให้เงินกู้
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type7_credit_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "7") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_credit
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทให้เงินกู้";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทให้เงินกู้";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกสหกรณ์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทจัดหาสินค้ามาจำหน่าย
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type7_sale_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "7") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_sale
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทจัดหาสินค้ามาจำหน่าย";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทจัดหาสินค้ามาจำหน่าย";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกสหกรณ์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทรวบรวมผลผลิต
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type7_collect_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "7") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_good
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทรวบรวมผลผลิต";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทรวบรวมผลผลิต";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกสหกรณ์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทแปรรูปผลผลิต
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type7_transfrom_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "7") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_marketing
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทแปรรูปผลผลิต";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทแปรรูปผลผลิต";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกสหกรณ์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทบริการ
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type7_service_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "7") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_service
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทบริการ";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทบริการ";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกสหกรณ์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })

      // การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทอื่น ๆ
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_type7_other_val", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = []
        let net = "หน่วย : คน"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "7") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_other
            })

          }
        }

        chart.data = data;
        chart.logo.disabled = true;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทอื่น ๆ";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทอื่น ๆ";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        /* Create axes */
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.fontSize = "11px"
        // //categoryAxis.title.text = "ปีชุดข้อมูล"

        /* Create value axis */
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"
        valueAxis.min = 0;
        /* Create series */
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.name = "การมีส่วนร่วมของสมาชิกสหกรณ์";
        columnSeries.dataFields.valueY = "value";
        columnSeries.dataFields.categoryX = "year";

        columnSeries.columns.template.tooltipText = "[#fff font-size: 15px]{name} ในปี {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
        columnSeries.columns.template.propertyFields.stroke = "stroke";
        columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
        columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
        columnSeries.tooltip.label.textAlign = "middle";

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "value";
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.categoryX = "year";

        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 3;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";

        let bullet = columnSeries.bullets.push(new am4charts.LabelBullet());
        bullet.tooltipText = "[#fff font-size: 15px]{name} in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#EA4755')

      })
    })
  }

  viewgraph(): void {
    // มาตรฐานสหกรณ์
    this.zone.runOutsideAngular(() => {
      this.CoopServiceService.GetCoopStandardTypeSum(this.OrgOrgId, this.PhakId, this.KhetId).subscribe(res => {
        // this.CoopServiceService.GetStandardYear().subscribe(res => {
        am4core.useTheme(am4themes_animated);
        setTimeout(() => {
        let chart = am4core.create("chartdiv_Standard", am4charts.PieChart);
        chart.hiddenState.properties.opacity = 0;

        let data = [];
        let sum_standard_pass_
        let sum_standard_not_

        sum_standard_pass_ = this.StandardTypeSum_pass;
        sum_standard_not_ = this.StandardTypeSum_notPass;
        data.push(
          {
            "country": "ผ่านมาตรฐาน",
            "value": sum_standard_pass_,
            "color": am4core.color("#44c70d")
          },
          {
            "country": "ไม่ผ่านมาตรฐาน",
            "value": sum_standard_not_,
            "color": am4core.color("#ca0000")
          }
        )

        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "มาตรฐานสหกรณ์";
        title.disabled = false;

        chart.data = data;
        chart.logo.disabled = true;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "มาตรฐานสหกรณ์";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        let series = chart.series.push(new am4charts.PieSeries());
        series.dataFields.value = "value";
        // series.dataFields.radiusValue = "value";
        series.dataFields.category = "country";
        series.slices.template.cornerRadius = 6;
        series.colors.step = 2;
        series.slices.template.propertyFields.fill = "color";
        series.hiddenState.properties.endAngle = -90;

        // เพิ่มตัวเลขในวงกลม
        series.alignLabels = false;
        series.ticks.template.disabled = true;
        series.labels.template.text = "{value.percent.formatNumber('#.0')}%";
        series.labels.template.radius = am4core.percent(-90);
        series.labels.template.fill = am4core.color("black");
        series.labels.template.relativeRotation = 90;

        // เปลี่ยนเปอร์เซ็นต์เป็นตัวเลข
        series.calculatePercent = true;
        series.labels.template.text = "{category}: {value.value}";
        series.slices.template.tooltipText = "{category}: {value.value}";

        chart.legend = new am4charts.Legend();
      },0);
      })
    })

    this.zone.runOutsideAngular(() => {

      this.CoopServiceService.GetCoopOracleCountNEW(this.OrgOrgId, this.PhakId, this.KhetId).subscribe(res => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_AN", am4charts.XYChart);
        let data = [];
        let year_now = this.year_now;

        chart.logo.disabled = true;
        let categoryAxis = chart.yAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.labels.template.disabled = true;
        categoryAxis.renderer.grid.template.opacity = 0;
        categoryAxis.fontSize = "11px"

        let valueAxis = chart.xAxes.push(new am4charts.ValueAxis());
        valueAxis.min = 0;
        valueAxis.renderer.grid.template.opacity = 0;
        valueAxis.renderer.ticks.template.strokeOpacity = 0.5;
        valueAxis.renderer.ticks.template.stroke = am4core.color("#495C43");
        valueAxis.renderer.ticks.template.length = 10;
        valueAxis.renderer.line.strokeOpacity = 0.5;
        valueAxis.renderer.baseGrid.disabled = true;
        valueAxis.renderer.minGridDistance = 40;
        valueAxis.fontSize = "11px"

        // Create series
        function createSeries(field, name, color) {
          let series = chart.series.push(new am4charts.ColumnSeries());
          series.dataFields.valueX = field;
          series.dataFields.categoryY = "year";
          series.stacked = true;
          series.name = name;
          series.columns.template.propertyFields.fill = color;
          series.columns.template.propertyFields.stroke = color;

          let columnTemplate = series.columns.template;
          columnTemplate.strokeWidth = 2;
          columnTemplate.strokeOpacity = 1;
          series.columns.template.propertyFields.fill = color;
          series.columns.template.propertyFields.stroke = color;

          let labelBullet = series.bullets.push(new am4charts.LabelBullet());
          labelBullet.locationX = 0.5;
          labelBullet.label.text = "{valueX}";
          labelBullet.label.fill = am4core.color("#fff");

        }

        chart.legend = new am4charts.Legend();
        for (let i = 0; i < res.length; i++) {
          // Add data
          data.push(
            {
              "year": year_now,
              "active": res[i].active,
              "nonactive": res[i].nonActive
            }
          )
        }
        chart.data = data;
        createSeries("active", "Active", "#4f9f0c");
        createSeries("nonactive", "Non-active", "#aa1107");

      })
    })

    // ระดับชั้นความเข้มแข็ง
    this.zone.runOutsideAngular(() => {
      this.CoopServiceService.GetCoopLevelCount(this.OrgOrgId, this.PhakId, this.KhetId).subscribe(res => {

        am4core.useTheme(am4themes_dataviz);
        if(res.length == 0){
          this.CoopLevelCountClose = true
        }else{
          this.CoopLevelCountClose = false
        }



        setTimeout(() => {
        var chart = am4core.create("chartdiv_Strong", am4charts.PieChart);
        chart.hiddenState.properties.opacity = 0;
        let data = [];

        if (parseInt(this.year_now) >= 2565) {
          res.pop();
        }

        for (let i = 0; i < res.length; i++) {
          data.push(
            {
              "level": res[i].level,
              "value": res[i].count,
              // "color": am4core.color("#1F9B8C")
            }
          );
        }

        chart.data = data;
        chart.logo.disabled = true;

        chart.radius = am4core.percent(70);
        chart.innerRadius = am4core.percent(40);
        chart.startAngle = 180;
        chart.endAngle = 360;

        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ระดับขั้นความเข้มแข็ง";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ระดับขั้นความเข้มแข็ง";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        var series = chart.series.push(new am4charts.PieSeries());
        series.dataFields.value = "value";
        series.dataFields.category = "level";
        series.slices.template.propertyFields.fill = "color";
        series.slices.template.propertyFields.stroke = "color";

        series.slices.template.cornerRadius = 10;
        series.slices.template.innerCornerRadius = 8;
        // series.slices.template.draggable = true;
        series.slices.template.inert = true;
        series.alignLabels = false;

        series.hiddenState.properties.startAngle = 90;
        series.hiddenState.properties.endAngle = 90;

        series.calculatePercent = true;
        series.labels.template.text = "{category}: {value.value}";
        series.slices.template.tooltipText = "{category}: {value.value}";

        chart.legend = new am4charts.Legend();
      },0);
      })
    });

    this.CoopServiceService.GetCoopFinance(this.OrgOrgId, this.PhakId, this.KhetId).subscribe(res => {
      res = callable.shiftYear(res, this.yearData);
      // สินทรัพย์
      this.zone.runOutsideAngular(() => {

        am4core.useTheme(am4themes_animated);

        let chart = am4core.create("chartdiv_asset", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = [];
        let net = "หน่วย : ล้านบาท"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].net_asset) {
            data.push({
              "year": res[i].year,
              "value": res[i].net_asset
            })
          }
        }

        chart.data = data;
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "สินทรัพย์ของสหกรณ์";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "สินทรัพย์ของสหกรณ์";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);
        // Create axes
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;

        categoryAxis.fontSize = "11px"
        // categoryAxis.title.text = "ปีข้อมูล"

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.minWidth = 50;
        valueAxis.fontSize = "11px"
        valueAxis.title.text = net


        // Create series
        let series = chart.series.push(new am4charts.ColumnSeries());
        series.sequencedInterpolation = true;
        series.dataFields.valueY = "value";
        series.dataFields.categoryX = "year";
        series.tooltipText = "[{categoryX}: bold]{valueY}[/]";
        series.columns.template.strokeWidth = 0;

        series.tooltip.pointerOrientation = "vertical";

        series.columns.template.column.cornerRadiusTopLeft = 10;
        series.columns.template.column.cornerRadiusTopRight = 10;
        series.columns.template.column.fillOpacity = 0.8;

        // on hover, make corner radiuses bigger
        let hoverState = series.columns.template.column.states.create("hover");
        hoverState.properties.cornerRadiusTopLeft = 0;
        hoverState.properties.cornerRadiusTopRight = 0;
        hoverState.properties.fillOpacity = 1;

        let bullet = series.bullets.push(new am4charts.LabelBullet())
        bullet.interactionsEnabled = false
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#000')

        series.columns.template.adapter.add("fill", function (fill, target) {
          return chart.colors.getIndex(target.dataItem.index);
        });

        chart.logo.disabled = true;
        // Cursor
        chart.cursor = new am4charts.XYCursor();
      })
      // หนี้สิน
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);

        let chart = am4core.create("chartdiv_debt", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = [];
        let net = "หน่วย : ล้านบาท"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].liabilities) {
            data.push({
              "year": res[i].year,
              "value": res[i].liabilities
            })
          }
        }

        chart.data = data;
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "หนี้สินของสหกรณ์";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "หนี้สินของสหกรณ์";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        // Create axes
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;

        categoryAxis.fontSize = "11px"
        // // categoryAxis.title.text = "ปีข้อมูล"

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.minWidth = 50;
        valueAxis.fontSize = "11px"
        valueAxis.title.text = net

        // Create series
        let series = chart.series.push(new am4charts.ColumnSeries());
        series.sequencedInterpolation = true;
        series.dataFields.valueY = "value";
        series.dataFields.categoryX = "year";
        series.tooltipText = "[{categoryX}: bold]{valueY}[/]";
        series.columns.template.strokeWidth = 0;

        series.tooltip.pointerOrientation = "vertical";

        series.columns.template.column.cornerRadiusTopLeft = 10;
        series.columns.template.column.cornerRadiusTopRight = 10;
        series.columns.template.column.fillOpacity = 0.8;

        // on hover, make corner radiuses bigger
        let hoverState = series.columns.template.column.states.create("hover");
        hoverState.properties.cornerRadiusTopLeft = 0;
        hoverState.properties.cornerRadiusTopRight = 0;
        hoverState.properties.fillOpacity = 1;

        let bullet = series.bullets.push(new am4charts.LabelBullet())
        bullet.interactionsEnabled = false
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#000')

        series.columns.template.adapter.add("fill", function (fill, target) {
          return chart.colors.getIndex(target.dataItem.index);
        });

        chart.logo.disabled = true;
        // Cursor
        chart.cursor = new am4charts.XYCursor();
      })

      // ทุน
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);

        let chart = am4core.create("chartdiv_Capital", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = [];
        let net = "หน่วย : ล้านบาท"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_capital) {
            data.push({
              "year": res[i].year,
              "value": res[i].coop_capital
            })
          }
        }

        chart.data = data;
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ทุนของสหกรณ์";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ทุนของสหกรณ์";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);
        // Create axes
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;

        categoryAxis.fontSize = "11px"
        // categoryAxis.title.text = "ปีข้อมูล"

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.minWidth = 50;
        valueAxis.fontSize = "11px"
        valueAxis.title.text = net

        // Create series
        let series = chart.series.push(new am4charts.ColumnSeries());
        series.sequencedInterpolation = true;
        series.dataFields.valueY = "value";
        series.dataFields.categoryX = "year";
        series.tooltipText = "[{categoryX}: bold]{valueY}[/]";
        series.columns.template.strokeWidth = 0;

        series.tooltip.pointerOrientation = "vertical";

        series.columns.template.column.cornerRadiusTopLeft = 10;
        series.columns.template.column.cornerRadiusTopRight = 10;
        series.columns.template.column.fillOpacity = 0.8;

        // on hover, make corner radiuses bigger
        let hoverState = series.columns.template.column.states.create("hover");
        hoverState.properties.cornerRadiusTopLeft = 0;
        hoverState.properties.cornerRadiusTopRight = 0;
        hoverState.properties.fillOpacity = 1;

        let bullet = series.bullets.push(new am4charts.LabelBullet())
        bullet.interactionsEnabled = false
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#000')

        series.columns.template.adapter.add("fill", function (fill, target) {
          return chart.colors.getIndex(target.dataItem.index);
        });

        chart.logo.disabled = true;
        // Cursor
        chart.cursor = new am4charts.XYCursor();
      })

      // กำไร
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);

        let chart = am4core.create("chartdiv_profit", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = [];
        let net = "หน่วย : ล้านบาท"
        // Add data
        for (let i = 0; i < res.length; i++) {
          if (res[i].net_profit) {
            data.push({
              "year": res[i].year,
              "value": res[i].net_profit
            })
          }
        }

        chart.data = data;
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "กำไร(ขาดทุน)ของสหกรณ์";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "กำไร(ขาดทุน)ของสหกรณ์";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        // Create axes
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;

        categoryAxis.fontSize = "11px"
        // categoryAxis.title.text = "ปีข้อมูล"

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.minWidth = 50;
        valueAxis.fontSize = "11px"
        valueAxis.title.text = net

        // Create series
        let series = chart.series.push(new am4charts.ColumnSeries());
        series.sequencedInterpolation = true;
        series.dataFields.valueY = "value";
        series.dataFields.categoryX = "year";
        series.tooltipText = "[{categoryX}: bold]{valueY}[/]";
        series.columns.template.strokeWidth = 0;

        series.tooltip.pointerOrientation = "vertical";

        series.columns.template.column.cornerRadiusTopLeft = 10;
        series.columns.template.column.cornerRadiusTopRight = 10;
        series.columns.template.column.fillOpacity = 0.8;

        // on hover, make corner radiuses bigger
        let hoverState = series.columns.template.column.states.create("hover");
        hoverState.properties.cornerRadiusTopLeft = 0;
        hoverState.properties.cornerRadiusTopRight = 0;
        hoverState.properties.fillOpacity = 1;

        let bullet = series.bullets.push(new am4charts.LabelBullet())
        bullet.interactionsEnabled = false
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#000')

        series.columns.template.adapter.add("fill", function (fill, target) {
          return chart.colors.getIndex(target.dataItem.index);
        });

        chart.logo.disabled = true;
        // Cursor
        chart.cursor = new am4charts.XYCursor();
      })
    });

    // this.CoopServiceService.GetCoopFinanceType(this.OrgOrgId, this.PhakId, this.KhetId).subscribe(res => {
    // สินทรัพย์ของสหกรณ์ ทุกประเภท
    // this.zone.runOutsideAngular(() => {
    //   am4core.useTheme(am4themes_animated);
    //   let chart = am4core.create("chartdiv_asset_type", am4charts.XYChart);
    //   chart.scrollbarX = new am4core.Scrollbar();
    //   chart.scrollbarY = new am4core.Scrollbar();

    //   let data = [];
    //   let net_asset_sum_1 = 0
    //   let net_asset_sum_2 = 0
    //   let net_asset_sum_3 = 0
    //   let net_asset_sum_4 = 0
    //   let net_asset_sum_5 = 0

    //   let year_now1
    //   let year_now2
    //   let year_now3
    //   let year_now4
    //   let year_now5
    //   for (let i = 0; i < res.length; i++) {

    //     if (res[0].year) {
    //       net_asset_sum_1 += res[i].net_asset.toFixed(0);
    //       year_now1 = res[i].year;

    //     }
    //     else if (res[1].year) {
    //       net_asset_sum_2 += res[i].net_asset.toFixed(0);
    //       year_now2 = res[i].year;
    //     }
    //     else if (res[2].year) {
    //       net_asset_sum_3 += res[i].net_asset.toFixed(0);
    //       year_now3 = res[i].year;
    //     }
    //     else if (res[3].year) {
    //       net_asset_sum_4 += res[i].net_asset.toFixed(0);
    //       year_now4 = res[i].year;
    //     }
    //     else if (res[4].year) {
    //       net_asset_sum_5 += res[i].net_asset.toFixed(0);
    //       year_now5 = res[i].year;
    //     }
    //   }

    //   // Add data
    //   data.push(
    //     {
    //       "year": year_now1,
    //       "value": net_asset_sum_1
    //     },
    //     {
    //       "year": year_now2,
    //       "value": net_asset_sum_2
    //     },
    //     {
    //       "year": year_now3,
    //       "value": net_asset_sum_3
    //     },
    //     {
    //       "year": year_now4,
    //       "value": net_asset_sum_4
    //     },
    //     {
    //       "year": year_now5,
    //       "value": net_asset_sum_5
    //     }
    //   )

    //   chart.data = data;
    //   // Export
    //   let title = chart.titles.create();
    //   title.fontSize = "11px";
    //   title.text = "สินทรัพย์ของสหกรณ์ ทุกประเภท";
    //   title.disabled = false;
    //   chart.exporting.menu = new am4core.ExportMenu();
    //   chart.exporting.filePrefix = "สินทรัพย์ของสหกรณ์ ทุกประเภท";
    //   chart.exporting.useWebFonts = false;
    //   chart.exporting.validateSprites.push(title);
    //   chart.exporting.validateSprites.push(title.parent);

    //   // Create axes
    //   let dateAxis = chart.xAxes.push(new am4charts.DateAxis());
    //   dateAxis.title.text = "ปีข้อมูล"
    //   dateAxis.fontSize = "11px"

    //   // Create value axis
    //   let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
    //   valueAxis.title.text = "หน่วย : ล้านบาท"
    //   valueAxis.fontSize = "11px"

    //   // Create series
    //   let lineSeries = chart.series.push(new am4charts.LineSeries());
    //   lineSeries.dataFields.valueY = "value";
    //   lineSeries.dataFields.dateX = "year";
    //   lineSeries.name = "Sales";
    //   lineSeries.strokeWidth = 3;

    //   // Add simple bullet
    //   let bullet = lineSeries.bullets.push(new am4charts.Bullet());
    //   let image = bullet.createChild(am4core.Image);
    //   image.href = "https://www.amcharts.com/lib/images/star.svg";
    //   image.width = 15;
    //   image.height = 15;
    //   image.horizontalCenter = "middle";
    //   image.verticalCenter = "middle";

    //   chart.logo.disabled = true;
    // })

    //หนี้สินของสหกรณ์ ทุกประเภท
    // this.zone.runOutsideAngular(() => {

    //   am4core.useTheme(am4themes_animated);
    //   let chart = am4core.create("chartdiv_debt_type", am4charts.XYChart);
    //   chart.scrollbarX = new am4core.Scrollbar();
    //   chart.scrollbarY = new am4core.Scrollbar();

    //   let data = [];
    //   let liabilities_sum_1 = 0
    //   let liabilities_sum_2 = 0
    //   let liabilities_sum_3 = 0
    //   let liabilities_sum_4 = 0
    //   let liabilities_sum_5 = 0

    //   let year_now1
    //   let year_now2
    //   let year_now3
    //   let year_now4
    //   let year_now5
    //   for (let i = 0; i < res.length; i++) {

    //     if (res[0].year) {
    //       liabilities_sum_1 += res[i].liabilities;
    //       year_now1 = res[i].year;

    //     }
    //     else if (res[1].year) {
    //       liabilities_sum_2 += res[i].liabilities;
    //       year_now2 = res[i].year;
    //     }
    //     else if (res[2].year) {
    //       liabilities_sum_3 += res[i].liabilities;
    //       year_now3 = res[i].year;
    //     }
    //     else if (res[3].year) {
    //       liabilities_sum_4 += res[i].liabilities;
    //       year_now4 = res[i].year;
    //     }
    //     else if (res[4].year) {
    //       liabilities_sum_5 += res[i].liabilities;
    //       year_now5 = res[i].year;
    //     }

    //   }

    //   data.push(
    //     {
    //       "year": year_now1,
    //       "value": liabilities_sum_1
    //     },
    //     {
    //       "year": year_now2,
    //       "value": liabilities_sum_2
    //     },
    //     {
    //       "year": year_now3,
    //       "value": liabilities_sum_3
    //     },
    //     {
    //       "year": year_now4,
    //       "value": liabilities_sum_4
    //     },
    //     {
    //       "year": year_now5,
    //       "value": liabilities_sum_5
    //     }
    //   )

    //   chart.data = data;
    //   // Export
    //   let title = chart.titles.create();
    //   title.fontSize = "11px";
    //   title.text = "หนี้สินของสหกรณ์ ทุกประเภท";
    //   title.disabled = false;
    //   chart.exporting.menu = new am4core.ExportMenu();
    //   chart.exporting.filePrefix = "หนี้สินของสหกรณ์ ทุกประเภท";
    //   chart.exporting.useWebFonts = false;
    //   chart.exporting.validateSprites.push(title);
    //   chart.exporting.validateSprites.push(title.parent);

    //   // Create axes
    //   let dateAxis = chart.xAxes.push(new am4charts.DateAxis());
    //   dateAxis.title.text = "ปีข้อมูล"
    //   dateAxis.fontSize = "11px"

    //   // Create value axis
    //   let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
    //   valueAxis.title.text = "หน่วย : ล้านบาท"
    //   valueAxis.fontSize = "11px"

    //   // Create series
    //   let lineSeries = chart.series.push(new am4charts.LineSeries());
    //   lineSeries.dataFields.valueY = "value";
    //   lineSeries.dataFields.dateX = "year";
    //   lineSeries.name = "Sales";
    //   lineSeries.strokeWidth = 3;

    //   // Add simple bullet
    //   let bullet = lineSeries.bullets.push(new am4charts.Bullet());
    //   let image = bullet.createChild(am4core.Image);
    //   image.href = "https://www.amcharts.com/lib/images/star.svg";
    //   image.width = 15;
    //   image.height = 15;
    //   image.horizontalCenter = "middle";
    //   image.verticalCenter = "middle";

    //   chart.logo.disabled = true;
    // })

    //ทุนของสหกรณ์ ทุกประเภท
    // this.zone.runOutsideAngular(() => {
    //   am4core.useTheme(am4themes_animated);
    //   let chart = am4core.create("chartdiv_Capital_type", am4charts.XYChart);
    //   chart.scrollbarX = new am4core.Scrollbar();
    //   chart.scrollbarY = new am4core.Scrollbar();

    //   let data = [];
    //   let coop_capital_sum_1 = 0
    //   let coop_capital_sum_2 = 0
    //   let coop_capital_sum_3 = 0
    //   let coop_capital_sum_4 = 0
    //   let coop_capital_sum_5 = 0

    //   let year_now1
    //   let year_now2
    //   let year_now3
    //   let year_now4
    //   let year_now5
    //   for (let i = 0; i < res.length; i++) {

    //     if (res[0].year) {
    //       coop_capital_sum_1 += res[i].coop_capital;
    //       year_now1 = res[i].year;

    //     }
    //     else if (res[1].year) {
    //       coop_capital_sum_2 += res[i].coop_capital;
    //       year_now2 = res[i].year;
    //     }
    //     else if (res[2].year) {
    //       coop_capital_sum_3 += res[i].coop_capital;
    //       year_now3 = res[i].year;
    //     }
    //     else if (res[3].year) {
    //       coop_capital_sum_4 += res[i].coop_capital;
    //       year_now4 = res[i].year;
    //     }
    //     else if (res[4].year) {
    //       coop_capital_sum_5 += res[i].coop_capital;
    //       year_now5 = res[i].year;
    //     }
    //   }

    //   // Add data
    //   data.push(
    //     {
    //       "year": year_now1,
    //       "value": coop_capital_sum_1
    //     },
    //     {
    //       "year": year_now2,
    //       "value": coop_capital_sum_2
    //     },
    //     {
    //       "year": year_now3,
    //       "value": coop_capital_sum_3
    //     },
    //     {
    //       "year": year_now4,
    //       "value": coop_capital_sum_4
    //     },
    //     {
    //       "year": year_now5,
    //       "value": coop_capital_sum_5
    //     }
    //   )

    //   chart.data = data;
    //   // Export
    //   let title = chart.titles.create();
    //   title.fontSize = "11px";
    //   title.text = "ทุนของสหกรณ์ ทุกประเภท";
    //   title.disabled = false;
    //   chart.exporting.menu = new am4core.ExportMenu();
    //   chart.exporting.filePrefix = "ทุนของสหกรณ์ ทุกประเภท";
    //   chart.exporting.useWebFonts = false;
    //   chart.exporting.validateSprites.push(title);
    //   chart.exporting.validateSprites.push(title.parent);

    //   // Create axes
    //   let dateAxis = chart.xAxes.push(new am4charts.DateAxis());
    //   dateAxis.title.text = "ปีข้อมูล"
    //   dateAxis.fontSize = "11px"

    //   // Create value axis
    //   let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
    //   valueAxis.title.text = "หน่วย : ล้านบาท"
    //   valueAxis.fontSize = "11px"

    //   // Create series
    //   let lineSeries = chart.series.push(new am4charts.LineSeries());
    //   lineSeries.dataFields.valueY = "value";
    //   lineSeries.dataFields.dateX = "year";
    //   lineSeries.name = "Sales";
    //   lineSeries.strokeWidth = 3;

    //   // Add simple bullet
    //   let bullet = lineSeries.bullets.push(new am4charts.Bullet());
    //   let image = bullet.createChild(am4core.Image);
    //   image.href = "https://www.amcharts.com/lib/images/star.svg";
    //   image.width = 15;
    //   image.height = 15;
    //   image.horizontalCenter = "middle";
    //   image.verticalCenter = "middle";

    //   chart.logo.disabled = true;
    // })

    //กำไรของสหกรณ์ ทุกประเภท
    // this.zone.runOutsideAngular(() => {
    //   am4core.useTheme(am4themes_animated);
    //   let chart = am4core.create("chartdiv_profit_type", am4charts.XYChart);
    //   chart.scrollbarX = new am4core.Scrollbar();
    //   chart.scrollbarY = new am4core.Scrollbar();

    //   let data = [];
    //   let net_profit_sum_1 = 0
    //   let net_profit_sum_2 = 0
    //   let net_profit_sum_3 = 0
    //   let net_profit_sum_4 = 0
    //   let net_profit_sum_5 = 0

    //   let year_now1
    //   let year_now2
    //   let year_now3
    //   let year_now4
    //   let year_now5
    //   for (let i = 0; i < res.length; i++) {

    //     if (res[0].year) {
    //       net_profit_sum_1 += res[i].net_profit;
    //       year_now1 = res[i].year;

    //     }
    //     else if (res[1].year) {
    //       net_profit_sum_2 += res[i].net_profit;
    //       year_now2 = res[i].year;
    //     }
    //     else if (res[2].year) {
    //       net_profit_sum_3 += res[i].net_profit;
    //       year_now3 = res[i].year;
    //     }
    //     else if (res[3].year) {
    //       net_profit_sum_4 += res[i].net_profit;
    //       year_now4 = res[i].year;
    //     }
    //     else if (res[4].year) {
    //       net_profit_sum_5 += res[i].net_profit;
    //       year_now5 = res[i].year;
    //     }
    //   }

    //   // Add data
    //   data.push(
    //     {
    //       "year": year_now1,
    //       "value": net_profit_sum_1
    //     },
    //     {
    //       "year": year_now2,
    //       "value": net_profit_sum_2
    //     },
    //     {
    //       "year": year_now3,
    //       "value": net_profit_sum_3
    //     },
    //     {
    //       "year": year_now4,
    //       "value": net_profit_sum_4
    //     },
    //     {
    //       "year": year_now5,
    //       "value": net_profit_sum_5
    //     }
    //   )

    //   chart.data = data;
    //   // Export
    //   let title = chart.titles.create();
    //   title.fontSize = "11px";
    //   title.text = "กำไรของสหกรณ์ ทุกประเภท";
    //   title.disabled = false;
    //   chart.exporting.menu = new am4core.ExportMenu();
    //   chart.exporting.filePrefix = "กำไรของสหกรณ์ ทุกประเภท";
    //   chart.exporting.useWebFonts = false;
    //   chart.exporting.validateSprites.push(title);
    //   chart.exporting.validateSprites.push(title.parent);

    //   // Create axes
    //   let dateAxis = chart.xAxes.push(new am4charts.DateAxis());
    //   dateAxis.title.text = "ปีข้อมูล"
    //   dateAxis.fontSize = "11px"

    //   // Create value axis
    //   let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
    //   valueAxis.title.text = "หน่วย : ล้านบาท"
    //   valueAxis.fontSize = "11px"

    //   // Create series
    //   let lineSeries = chart.series.push(new am4charts.LineSeries());
    //   lineSeries.dataFields.valueY = "value";
    //   lineSeries.dataFields.dateX = "year";
    //   lineSeries.name = "Sales";
    //   lineSeries.strokeWidth = 3;

    //   // Add simple bullet
    //   let bullet = lineSeries.bullets.push(new am4charts.Bullet());
    //   let image = bullet.createChild(am4core.Image);
    //   image.href = "https://www.amcharts.com/lib/images/star.svg";
    //   image.width = 15;
    //   image.height = 15;
    //   image.horizontalCenter = "middle";
    //   image.verticalCenter = "middle";

    //   chart.logo.disabled = true;
    // })
    // });

    this.CoopServiceService.GetCoopBussiness(this.OrgOrgId, this.PhakId, this.KhetId).subscribe(res => {
      res = callable.shiftYear(res, this.yearData);
      // ปริมาณธุรกิจ
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();
        let data = [];
        let net = "หน่วย : ล้านบาท"
        let valSum1
        let valSum2
        let valSum3
        let valSum4
        let valSum5

        for (let i = 0; i < res.length; i++) {

          if (res[0].year) {
            this.valSum1 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
            valSum1 = this.valSum1
            data.push({
              "year": res[i].year,
              "value": valSum1
            })
          }
          else if (res[1].year) {
            this.valSum2 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
            valSum2 = this.valSum2
            data.push({
              "year": res[i].year,
              "value": valSum2
            })
          }
          else if (res[2].year) {
            this.valSum3 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
            valSum3 = this.valSum3
            data.push({
              "year": res[i].year,
              "value": valSum3
            })
          }
          else if (res[3].year) {
            this.valSum4 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
            valSum4 = this.valSum4
            data.push({
              "year": res[i].year,
              "value": valSum4
            })
          }
          else if (res[4].year) {
            this.valSum5 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
            valSum5 = this.valSum5
            data.push({
              "year": res[i].year,
              "value": valSum5
            })
          }

        }

        chart.data = data;
        // Create axes
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;

        categoryAxis.fontSize = "11px"
        //categoryAxis.title.text = "ปีชุดข้อมูล"

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.minWidth = 50;
        valueAxis.fontSize = "11px"
        valueAxis.title.text = net

        // Create series
        let series = chart.series.push(new am4charts.ColumnSeries());
        series.sequencedInterpolation = true;
        series.dataFields.valueY = "value";
        series.dataFields.categoryX = "year";
        series.tooltipText = "[{categoryX}: bold]{valueY}[/]";
        series.columns.template.strokeWidth = 0;

        series.tooltip.pointerOrientation = "vertical";

        series.columns.template.column.cornerRadiusTopLeft = 10;
        series.columns.template.column.cornerRadiusTopRight = 10;
        series.columns.template.column.fillOpacity = 0.8;

        // on hover, make corner radiuses bigger
        let hoverState = series.columns.template.column.states.create("hover");
        hoverState.properties.cornerRadiusTopLeft = 0;
        hoverState.properties.cornerRadiusTopRight = 0;
        hoverState.properties.fillOpacity = 1;

        let bullet = series.bullets.push(new am4charts.LabelBullet())
        bullet.interactionsEnabled = false
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#000')

        series.columns.template.adapter.add("fill", function (fill, target) {
          return chart.colors.getIndex(target.dataItem.index);
        });

        chart.logo.disabled = true;
        // Cursor
        chart.cursor = new am4charts.XYCursor();
      })
    });

    this.CoopServiceService.GetCoopBussinessType(this.OrgOrgId, this.PhakId, this.KhetId).subscribe(res => {
      res = callable.shiftYear(res, this.yearData);
      // ปริมาณธุรกิจ ประมง
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);

        let chart = am4core.create("chartdiv_business_type2", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();
        let data = [];
        let net = "หน่วย : ล้านบาท"
        let valSum1
        let valSum2
        let valSum3
        let valSum4
        let valSum5

        for (let i = 0; i < res.length; i++) {

          if (res[i].coop_type == '2') {

            if (res[0].year) {
              this.valSum1 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
              valSum1 = this.valSum1
              data.push({
                "year": res[i].year,
                "value": valSum1
              })
            }
            else if (res[1].year) {
              this.valSum2 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
              valSum2 = this.valSum2
              data.push({
                "year": res[i].year,
                "value": valSum2
              })
            }
            else if (res[2].year) {
              this.valSum3 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
              valSum3 = this.valSum3
              data.push({
                "year": res[i].year,
                "value": valSum3
              })
            }
            else if (res[3].year) {
              this.valSum4 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
              valSum4 = this.valSum4
              data.push({
                "year": res[i].year,
                "value": valSum4
              })
            }
            else if (res[4].year) {
              this.valSum5 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
              valSum5 = this.valSum5
              data.push({
                "year": res[i].year,
                "value": valSum5
              })
            }

          }
        }
        chart.data = data;
        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจ ประเภทสหกรณ์ประมง";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจ ประเภทสหกรณ์ประมง";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        // Create axes
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;

        categoryAxis.fontSize = "11px"
        //categoryAxis.title.text = "ปีชุดข้อมูล"

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.minWidth = 50;
        valueAxis.fontSize = "11px"
        valueAxis.title.text = net

        // Create series
        let series = chart.series.push(new am4charts.ColumnSeries());
        series.sequencedInterpolation = true;
        series.dataFields.valueY = "value";
        series.dataFields.categoryX = "year";
        series.tooltipText = "[{categoryX}: bold]{valueY}[/]";
        series.columns.template.strokeWidth = 0;

        series.tooltip.pointerOrientation = "vertical";

        series.columns.template.column.cornerRadiusTopLeft = 10;
        series.columns.template.column.cornerRadiusTopRight = 10;
        series.columns.template.column.fillOpacity = 0.8;

        // on hover, make corner radiuses bigger
        let hoverState = series.columns.template.column.states.create("hover");
        hoverState.properties.cornerRadiusTopLeft = 0;
        hoverState.properties.cornerRadiusTopRight = 0;
        hoverState.properties.fillOpacity = 1;

        let bullet = series.bullets.push(new am4charts.LabelBullet())
        bullet.interactionsEnabled = false
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#000')

        series.columns.template.adapter.add("fill", function (fill, target) {
          return chart.colors.getIndex(target.dataItem.index);
        });

        chart.logo.disabled = true;
        // Cursor
        chart.cursor = new am4charts.XYCursor();
      })

      // ปริมาณธุรกิจ นิคม
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);

        let chart = am4core.create("chartdiv_business_type3", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();
        let data = [];
        let net = "หน่วย : ล้านบาท"
        let valSum1
        let valSum2
        let valSum3
        let valSum4
        let valSum5

        for (let i = 0; i < res.length; i++) {

          if (res[i].coop_type == '3') {

            if (res[0].year) {
              this.valSum1 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
              valSum1 = this.valSum1
              data.push({
                "year": res[i].year,
                "value": valSum1
              })
            }
            else if (res[1].year) {
              this.valSum2 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
              valSum2 = this.valSum2
              data.push({
                "year": res[i].year,
                "value": valSum2
              })
            }
            else if (res[2].year) {
              this.valSum3 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
              valSum3 = this.valSum3
              data.push({
                "year": res[i].year,
                "value": valSum3
              })
            }
            else if (res[3].year) {
              this.valSum4 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
              valSum4 = this.valSum4
              data.push({
                "year": res[i].year,
                "value": valSum4
              })
            }
            else if (res[4].year) {
              this.valSum5 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
              valSum5 = this.valSum5
              data.push({
                "year": res[i].year,
                "value": valSum5
              })
            }
          }

        }

        chart.data = data;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจ ประเภทสหกรณ์นิคม";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจ ประเภทสหกรณ์นิคม";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        // Create axes
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;

        categoryAxis.fontSize = "11px"
        //categoryAxis.title.text = "ปีชุดข้อมูล"

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.minWidth = 50;
        valueAxis.fontSize = "11px"
        valueAxis.title.text = net

        // Create series
        let series = chart.series.push(new am4charts.ColumnSeries());
        series.sequencedInterpolation = true;
        series.dataFields.valueY = "value";
        series.dataFields.categoryX = "year";
        series.tooltipText = "[{categoryX}: bold]{valueY}[/]";
        series.columns.template.strokeWidth = 0;

        series.tooltip.pointerOrientation = "vertical";

        series.columns.template.column.cornerRadiusTopLeft = 10;
        series.columns.template.column.cornerRadiusTopRight = 10;
        series.columns.template.column.fillOpacity = 0.8;

        // on hover, make corner radiuses bigger
        let hoverState = series.columns.template.column.states.create("hover");
        hoverState.properties.cornerRadiusTopLeft = 0;
        hoverState.properties.cornerRadiusTopRight = 0;
        hoverState.properties.fillOpacity = 1;

        let bullet = series.bullets.push(new am4charts.LabelBullet())
        bullet.interactionsEnabled = false
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#000')

        series.columns.template.adapter.add("fill", function (fill, target) {
          return chart.colors.getIndex(target.dataItem.index);
        });

        chart.logo.disabled = true;
        // Cursor
        chart.cursor = new am4charts.XYCursor();
      })

      // ปริมาณธุรกิจ ออมทรัพย์
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);

        let chart = am4core.create("chartdiv_business_type4", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();
        let data = [];
        let net = "หน่วย : ล้านบาท"
        let valSum1
        let valSum2
        let valSum3
        let valSum4
        let valSum5

        for (let i = 0; i < res.length; i++) {

          if (res[i].coop_type == '4') {

            if (res[0].year) {
              this.valSum1 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
              valSum1 = this.valSum1
              data.push({
                "year": res[i].year,
                "value": valSum1
              })
            }
            else if (res[1].year) {
              this.valSum2 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
              valSum2 = this.valSum2
              data.push({
                "year": res[i].year,
                "value": valSum2
              })
            }
            else if (res[2].year) {
              this.valSum3 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
              valSum3 = this.valSum3
              data.push({
                "year": res[i].year,
                "value": valSum3
              })
            }
            else if (res[2].year) {
              this.valSum4 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
              valSum4 = this.valSum4

              data.push({
                "year": res[i].year,
                "value": valSum4
              })
            }
            else if (res[3].year) {
              this.valSum5 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
              valSum5 = this.valSum5
              data.push({
                "year": res[i].year,
                "value": valSum5
              })
            }

          }
        }

        chart.data = data;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจ ประเภทสหกรณ์ออมทรัพย์";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจ ประเภทสหกรณ์ออมทรัพย์";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        // Create axes
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;

        categoryAxis.fontSize = "11px"
        //categoryAxis.title.text = "ปีชุดข้อมูล"

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.minWidth = 50;
        valueAxis.fontSize = "11px"
        valueAxis.title.text = net

        // Create series
        let series = chart.series.push(new am4charts.ColumnSeries());
        series.sequencedInterpolation = true;
        series.dataFields.valueY = "value";
        series.dataFields.categoryX = "year";
        series.tooltipText = "[{categoryX}: bold]{valueY}[/]";
        series.columns.template.strokeWidth = 0;

        series.tooltip.pointerOrientation = "vertical";

        series.columns.template.column.cornerRadiusTopLeft = 10;
        series.columns.template.column.cornerRadiusTopRight = 10;
        series.columns.template.column.fillOpacity = 0.8;

        // on hover, make corner radiuses bigger
        let hoverState = series.columns.template.column.states.create("hover");
        hoverState.properties.cornerRadiusTopLeft = 0;
        hoverState.properties.cornerRadiusTopRight = 0;
        hoverState.properties.fillOpacity = 1;

        let bullet = series.bullets.push(new am4charts.LabelBullet())
        bullet.interactionsEnabled = false
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#000')

        series.columns.template.adapter.add("fill", function (fill, target) {
          return chart.colors.getIndex(target.dataItem.index);
        });

        chart.logo.disabled = true;
        // Cursor
        chart.cursor = new am4charts.XYCursor();
      })

      // ปริมาณธุรกิจ ร้านค้า
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);

        let chart = am4core.create("chartdiv_business_type5", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();
        let data = [];
        let net = "หน่วย : ล้านบาท"
        let valSum1
        let valSum2
        let valSum3
        let valSum4
        let valSum5

        for (let i = 0; i < res.length; i++) {

          if (res[i].coop_type == '5') {

            if (res[0].year) {
              this.valSum1 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
              valSum1 = this.valSum1
              data.push({
                "year": res[i].year,
                "value": valSum1
              })
            }
            else if (res[1].year) {
              this.valSum2 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
              valSum2 = this.valSum2
              data.push({
                "year": res[i].year,
                "value": valSum2
              })
            }
            else if (res[2].year) {
              this.valSum3 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
              valSum3 = this.valSum3
              data.push({
                "year": res[i].year,
                "value": valSum3
              })
            }
            else if (res[3].year) {
              this.valSum4 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
              valSum4 = this.valSum4
              data.push({
                "year": res[i].year,
                "value": valSum4
              })
            }
            else if (res[4].year) {
              this.valSum5 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
              valSum5 = this.valSum5
              data.push({
                "year": res[i].year,
                "value": valSum5
              })
            }

          }
        }

        chart.data = data;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจ ประเภทสหกรณ์ร้านค้า";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจ ประเภทสหกรณ์ร้านค้า";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        // Create axes
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;

        categoryAxis.fontSize = "11px"
        //categoryAxis.title.text = "ปีชุดข้อมูล"

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.minWidth = 50;
        valueAxis.fontSize = "11px"
        valueAxis.title.text = net

        // Create series
        let series = chart.series.push(new am4charts.ColumnSeries());
        series.sequencedInterpolation = true;
        series.dataFields.valueY = "value";
        series.dataFields.categoryX = "year";
        series.tooltipText = "[{categoryX}: bold]{valueY}[/]";
        series.columns.template.strokeWidth = 0;

        series.tooltip.pointerOrientation = "vertical";

        series.columns.template.column.cornerRadiusTopLeft = 10;
        series.columns.template.column.cornerRadiusTopRight = 10;
        series.columns.template.column.fillOpacity = 0.8;

        // on hover, make corner radiuses bigger
        let hoverState = series.columns.template.column.states.create("hover");
        hoverState.properties.cornerRadiusTopLeft = 0;
        hoverState.properties.cornerRadiusTopRight = 0;
        hoverState.properties.fillOpacity = 1;

        let bullet = series.bullets.push(new am4charts.LabelBullet())
        bullet.interactionsEnabled = false
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#000')

        series.columns.template.adapter.add("fill", function (fill, target) {
          return chart.colors.getIndex(target.dataItem.index);
        });

        chart.logo.disabled = true;
        // Cursor
        chart.cursor = new am4charts.XYCursor();
      })

      // ปริมาณธุรกิจ บริการ
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);

        let chart = am4core.create("chartdiv_business_type6", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();
        let data = [];
        let net = "หน่วย : ล้านบาท"
        let valSum1
        let valSum2
        let valSum3
        let valSum4
        let valSum5

        for (let i = 0; i < res.length; i++) {

          if (res[i].coop_type == '6') {

            if (res[0].year) {
              this.valSum1 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
              valSum1 = this.valSum1
              data.push({
                "year": res[i].year,
                "value": valSum1
              })
            }
            else if (res[1].year) {
              this.valSum2 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
              valSum2 = this.valSum2
              data.push({
                "year": res[i].year,
                "value": valSum2
              })
            }
            else if (res[2].year) {
              this.valSum3 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
              valSum3 = this.valSum3
              data.push({
                "year": res[i].year,
                "value": valSum3
              })
            }
            else if (res[3].year) {
              this.valSum4 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
              valSum4 = this.valSum4

              data.push({
                "year": res[i].year,
                "value": valSum4
              })
            }
            else if (res[4].year) {
              this.valSum5 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
              valSum5 = this.valSum5
              data.push({
                "year": res[i].year,
                "value": valSum5
              })
            }

          }
        }

        chart.data = data;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจ ประเภทสหกรณ์บริการ";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจ ประเภทสหกรณ์บริการ";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        // Create axes
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;

        categoryAxis.fontSize = "11px"
        //categoryAxis.title.text = "ปีชุดข้อมูล"

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.minWidth = 50;
        valueAxis.fontSize = "11px"
        valueAxis.title.text = net

        // Create series
        let series = chart.series.push(new am4charts.ColumnSeries());
        series.sequencedInterpolation = true;
        series.dataFields.valueY = "value";
        series.dataFields.categoryX = "year";
        series.tooltipText = "[{categoryX}: bold]{valueY}[/]";
        series.columns.template.strokeWidth = 0;

        series.tooltip.pointerOrientation = "vertical";

        series.columns.template.column.cornerRadiusTopLeft = 10;
        series.columns.template.column.cornerRadiusTopRight = 10;
        series.columns.template.column.fillOpacity = 0.8;

        // on hover, make corner radiuses bigger
        let hoverState = series.columns.template.column.states.create("hover");
        hoverState.properties.cornerRadiusTopLeft = 0;
        hoverState.properties.cornerRadiusTopRight = 0;
        hoverState.properties.fillOpacity = 1;

        let bullet = series.bullets.push(new am4charts.LabelBullet())
        bullet.interactionsEnabled = false
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#000')

        series.columns.template.adapter.add("fill", function (fill, target) {
          return chart.colors.getIndex(target.dataItem.index);
        });

        chart.logo.disabled = true;
        // Cursor
        chart.cursor = new am4charts.XYCursor();
      })

      // ปริมาณธุรกิจ เครดิต
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);

        let chart = am4core.create("chartdiv_business_type7", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();
        let data = [];
        let net = "หน่วย : ล้านบาท"
        let valSum1
        let valSum2
        let valSum3
        let valSum4
        let valSum5

        for (let i = 0; i < res.length; i++) {

          if (res[i].coop_type == '7') {

            if (res[0].year) {
              this.valSum1 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
              valSum1 = this.valSum1
              data.push({
                "year": res[i].year,
                "value": valSum1
              })
            }
            else if (res[1].year) {
              this.valSum2 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
              valSum2 = this.valSum2
              data.push({
                "year": res[i].year,
                "value": valSum2
              })
            }
            else if (res[2].year) {
              this.valSum3 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
              valSum3 = this.valSum3
              data.push({
                "year": res[i].year,
                "value": valSum3
              })
            }
            else if (res[3].year) {
              this.valSum4 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
              valSum4 = this.valSum4
              data.push({
                "year": res[i].year,
                "value": valSum4
              })
            }
            else if (res[4].year) {
              this.valSum5 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
              valSum5 = this.valSum5
              data.push({
                "year": res[i].year,
                "value": valSum5
              })
            }

          }
        }

        chart.data = data;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจ ประเภทสหกรณ์เครดิตยูเนี่ยน";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจ ประเภทสหกรณ์เครดิตยูเนี่ยน";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        // Create axes
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;

        categoryAxis.fontSize = "11px"
        //categoryAxis.title.text = "ปีชุดข้อมูล"

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.minWidth = 50;
        valueAxis.fontSize = "11px"
        valueAxis.title.text = net

        // Create series
        let series = chart.series.push(new am4charts.ColumnSeries());
        series.sequencedInterpolation = true;
        series.dataFields.valueY = "value";
        series.dataFields.categoryX = "year";
        series.tooltipText = "[{categoryX}: bold]{valueY}[/]";
        series.columns.template.strokeWidth = 0;

        series.tooltip.pointerOrientation = "vertical";

        series.columns.template.column.cornerRadiusTopLeft = 10;
        series.columns.template.column.cornerRadiusTopRight = 10;
        series.columns.template.column.fillOpacity = 0.8;

        // on hover, make corner radiuses bigger
        let hoverState = series.columns.template.column.states.create("hover");
        hoverState.properties.cornerRadiusTopLeft = 0;
        hoverState.properties.cornerRadiusTopRight = 0;
        hoverState.properties.fillOpacity = 1;

        let bullet = series.bullets.push(new am4charts.LabelBullet())
        bullet.interactionsEnabled = false
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#000')

        series.columns.template.adapter.add("fill", function (fill, target) {
          return chart.colors.getIndex(target.dataItem.index);
        });

        chart.logo.disabled = true;
        // Cursor
        chart.cursor = new am4charts.XYCursor();
      })

      // ปริมาณธุรกิจ เกษตร
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);

        let chart = am4core.create("chartdiv_business_type1", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();
        let data = [];
        let net = "หน่วย : ล้านบาท"
        let valSum1
        let valSum2
        let valSum3
        let valSum4
        let valSum5

        for (let i = 0; i < res.length; i++) {

          if (res[i].coop_type == '1') {

            if (res[0].year) {
              this.valSum1 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
              valSum1 = this.valSum1
              data.push({
                "year": res[i].year,
                "value": valSum1
              })
            }
            else if (res[1].year) {
              this.valSum2 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
              valSum2 = this.valSum2
              data.push({
                "year": res[i].year,
                "value": valSum2
              })
            }
            else if (res[2].year) {
              this.valSum3 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
              valSum3 = this.valSum3
              data.push({
                "year": res[i].year,
                "value": valSum3
              })
            }
            else if (res[3].year) {
              this.valSum4 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
              valSum4 = this.valSum4
              data.push({
                "year": res[i].year,
                "value": valSum4
              })
            }
            else if (res[4].year) {
              this.valSum5 = (res[i].deposit_val + res[i].credit_val + res[i].sale_val + res[i].collect_val + res[i].transfrom_val + res[i].service_val);
              valSum5 = this.valSum5
              data.push({
                "year": res[i].year,
                "value": valSum5
              })
            }
          }

        }

        chart.data = data;
        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจ ประเภทสหกรณ์การเกษตร";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจ ประเภทสหกรณ์การเกษตร";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        // Create axes
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;

        categoryAxis.fontSize = "11px"
        //categoryAxis.title.text = "ปีชุดข้อมูล"

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.minWidth = 50;
        valueAxis.fontSize = "11px"
        valueAxis.title.text = net

        // Create series
        let series = chart.series.push(new am4charts.ColumnSeries());
        series.sequencedInterpolation = true;
        series.dataFields.valueY = "value";
        series.dataFields.categoryX = "year";
        series.tooltipText = "[{categoryX}: bold]{valueY}[/]";
        series.columns.template.strokeWidth = 0;

        series.tooltip.pointerOrientation = "vertical";

        series.columns.template.column.cornerRadiusTopLeft = 10;
        series.columns.template.column.cornerRadiusTopRight = 10;
        series.columns.template.column.fillOpacity = 0.8;

        // on hover, make corner radiuses bigger
        let hoverState = series.columns.template.column.states.create("hover");
        hoverState.properties.cornerRadiusTopLeft = 0;
        hoverState.properties.cornerRadiusTopRight = 0;
        hoverState.properties.fillOpacity = 1;

        let bullet = series.bullets.push(new am4charts.LabelBullet())
        bullet.interactionsEnabled = false
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#000')

        series.columns.template.adapter.add("fill", function (fill, target) {
          return chart.colors.getIndex(target.dataItem.index);
        });

        chart.logo.disabled = true;
        // Cursor
        chart.cursor = new am4charts.XYCursor();
      })

      //ปริมาณธุรกิจ (รับฝากเงิน) แบ่งตามประเภทสหกรณ์
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_deposit_type", am4charts.XYChart);

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        let data = [];
        let net = "หน่วย : ล้านบาท"
        let sum_1 = 0
        let sum_2 = 0
        let sum_3 = 0
        let sum_4 = 0
        let sum_5 = 0

        for (let i = 0; i < res.length; i++) {

          if (res[0].year) {
            sum_1 += res[i].deposit_val;
            data.push({
              "year": res[i].year,
              "value": sum_1
            })

          }
          else if (res[1].year) {
            sum_2 += res[i].deposit_val;
            data.push({
              "year": res[i].year,
              "value": sum_2
            })
          }
          else if (res[2].year) {
            sum_3 += res[i].deposit_val;
            data.push({
              "year": res[i].year,
              "value": sum_3
            })
          }
          else if (res[3].year) {
            sum_4 += res[i].deposit_val;
            data.push({
              "year": res[i].year,
              "value": sum_4
            })
          }
          else if (res[4].year) {
            sum_5 += res[i].deposit_val;
            data.push({
              "year": res[i].year,
              "value": sum_5
            })
          }
        }

        chart.data = data;

        // Create axes
        let dateAxis = chart.xAxes.push(new am4charts.DateAxis());
        dateAxis.title.text = "ปีชุดข้อมูล"
        dateAxis.fontSize = "11px"

        // Create value axis
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = net
        valueAxis.fontSize = "11px"

        // Create series
        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.dataFields.valueY = "value";
        lineSeries.dataFields.dateX = "year";
        lineSeries.name = "Sales";
        lineSeries.strokeWidth = 3;

        // Add simple bullet
        let bullet = lineSeries.bullets.push(new am4charts.Bullet());
        let image = bullet.createChild(am4core.Image);
        image.href = "https://www.amcharts.com/lib/images/star.svg";
        image.width = 15;
        image.height = 15;
        image.horizontalCenter = "middle";
        image.verticalCenter = "middle";

        chart.logo.disabled = true;
      })

    });

    // การมีส่วนร่วมของสมาชิกสหกรณ์
    this.zone.runOutsideAngular(() => {
      this.CoopServiceService.GetCoopProfileBussiness(this.OrgOrgId, this.PhakId, this.KhetId).subscribe(res => {
        res = callable.shiftYear(res, this.yearData);
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_coop_sum", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();

        let data = [];

        for (let i = 0; i < res.length; i++) {
          if (res[i].year != '2558') {
            data.push(
              {
                "year": res[i].year,
                "value": res[i].sum_member
              }
            )
          }
        }


        chart.data = data;
        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกสหกรณ์";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกสหกรณ์";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);
        // Create axes
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;

        categoryAxis.fontSize = "11px"
        // categoryAxis.title.text = "ปีข้อมูล"

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.minWidth = 50;
        valueAxis.fontSize = "11px"
        valueAxis.title.text = "หน่วย : คน"

        // Create series
        let series = chart.series.push(new am4charts.ColumnSeries());
        series.sequencedInterpolation = true;
        series.dataFields.valueY = "value";
        series.dataFields.categoryX = "year";
        series.tooltipText = "[{categoryX}: bold]{valueY}[/]";
        series.columns.template.strokeWidth = 0;

        series.tooltip.pointerOrientation = "vertical";

        series.columns.template.column.cornerRadiusTopLeft = 10;
        series.columns.template.column.cornerRadiusTopRight = 10;
        series.columns.template.column.fillOpacity = 0.8;

        let bullet = series.bullets.push(new am4charts.LabelBullet())
        bullet.interactionsEnabled = false
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#000')

        // on hover, make corner radiuses bigger
        let hoverState = series.columns.template.column.states.create("hover");
        hoverState.properties.cornerRadiusTopLeft = 0;
        hoverState.properties.cornerRadiusTopRight = 0;
        hoverState.properties.fillOpacity = 1;

        series.columns.template.adapter.add("fill", function (fill, target) {
          return chart.colors.getIndex(target.dataItem.index);
        });

        chart.logo.disabled = true;
        // Cursor
        chart.cursor = new am4charts.XYCursor();

      })
    })

    this.CoopServiceService.GetCoopProfileBussinessType(this.OrgOrgId, this.PhakId, this.KhetId).subscribe(res => {
      res = callable.shiftYear(res, this.yearData);
      // การมีส่วนร่วมของสมาชิกสหกรณ์ การเกษตร
      this.zone.runOutsideAngular(() => {

        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_coop", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();

        let data = [];

        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "1") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_member
            })
          }
        }

        chart.data = data;
        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกสหกรณ ประเภทการเกษตร";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกสหกรณ ประเภทการเกษตร";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);
        // Create axes
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;

        categoryAxis.fontSize = "11px"
        // categoryAxis.title.text = "ปีข้อมูล"

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.minWidth = 50;
        valueAxis.fontSize = "11px"
        valueAxis.title.text = "หน่วย : คน"

        // Create series
        let series = chart.series.push(new am4charts.ColumnSeries());
        series.sequencedInterpolation = true;
        series.dataFields.valueY = "value";
        series.dataFields.categoryX = "year";
        series.tooltipText = "[{categoryX}: bold]{valueY}[/]";
        series.columns.template.strokeWidth = 0;

        series.tooltip.pointerOrientation = "vertical";

        series.columns.template.column.cornerRadiusTopLeft = 10;
        series.columns.template.column.cornerRadiusTopRight = 10;
        series.columns.template.column.fillOpacity = 0.8;

        let bullet = series.bullets.push(new am4charts.LabelBullet())
        bullet.interactionsEnabled = false
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#000')

        // on hover, make corner radiuses bigger
        let hoverState = series.columns.template.column.states.create("hover");
        hoverState.properties.cornerRadiusTopLeft = 0;
        hoverState.properties.cornerRadiusTopRight = 0;
        hoverState.properties.fillOpacity = 1;

        series.columns.template.adapter.add("fill", function (fill, target) {
          return chart.colors.getIndex(target.dataItem.index);
        });

        chart.logo.disabled = true;
        // Cursor
        chart.cursor = new am4charts.XYCursor();

      })

      // การมีส่วนร่วมของสมาชิกสหกรณ์ ประมง
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_fishing", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();

        let data = [];

        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "2") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_member
            })
          }
        }

        chart.data = data;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกสหกรณ ประเภทประมง";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกสหกรณ ประเภทประมง";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        // Create axes
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;

        categoryAxis.fontSize = "11px"
        // categoryAxis.title.text = "ปีข้อมูล"

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.minWidth = 50;
        valueAxis.fontSize = "11px"
        valueAxis.title.text = "หน่วย : คน"

        // Create series
        let series = chart.series.push(new am4charts.ColumnSeries());
        series.sequencedInterpolation = true;
        series.dataFields.valueY = "value";
        series.dataFields.categoryX = "year";
        series.tooltipText = "[{categoryX}: bold]{valueY}[/]";
        series.columns.template.strokeWidth = 0;

        series.tooltip.pointerOrientation = "vertical";

        series.columns.template.column.cornerRadiusTopLeft = 10;
        series.columns.template.column.cornerRadiusTopRight = 10;
        series.columns.template.column.fillOpacity = 0.8;

        let bullet = series.bullets.push(new am4charts.LabelBullet())
        bullet.interactionsEnabled = false
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#000')

        // on hover, make corner radiuses bigger
        let hoverState = series.columns.template.column.states.create("hover");
        hoverState.properties.cornerRadiusTopLeft = 0;
        hoverState.properties.cornerRadiusTopRight = 0;
        hoverState.properties.fillOpacity = 1;

        series.columns.template.adapter.add("fill", function (fill, target) {
          return chart.colors.getIndex(target.dataItem.index);
        });

        chart.logo.disabled = true;
        // Cursor
        chart.cursor = new am4charts.XYCursor();

      })

      // การมีส่วนร่วมของสมาชิกสหกรณ์ นิคม
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_Settlement", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();

        let data = [];

        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "3") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_member
            })
          }
        }

        chart.data = data;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกสหกรณ ประเภทนิคม";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกสหกรณ ประเภทนิคม";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        // Create axes
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;

        categoryAxis.fontSize = "11px"
        // categoryAxis.title.text = "ปีข้อมูล"

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.minWidth = 50;
        valueAxis.fontSize = "11px"
        valueAxis.title.text = "หน่วย : คน"

        // Create series
        let series = chart.series.push(new am4charts.ColumnSeries());
        series.sequencedInterpolation = true;
        series.dataFields.valueY = "value";
        series.dataFields.categoryX = "year";
        series.tooltipText = "[{categoryX}: bold]{valueY}[/]";
        series.columns.template.strokeWidth = 0;

        series.tooltip.pointerOrientation = "vertical";

        series.columns.template.column.cornerRadiusTopLeft = 10;
        series.columns.template.column.cornerRadiusTopRight = 10;
        series.columns.template.column.fillOpacity = 0.8;

        let bullet = series.bullets.push(new am4charts.LabelBullet())
        bullet.interactionsEnabled = false
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#000')

        // on hover, make corner radiuses bigger
        let hoverState = series.columns.template.column.states.create("hover");
        hoverState.properties.cornerRadiusTopLeft = 0;
        hoverState.properties.cornerRadiusTopRight = 0;
        hoverState.properties.fillOpacity = 1;

        series.columns.template.adapter.add("fill", function (fill, target) {
          return chart.colors.getIndex(target.dataItem.index);
        });

        chart.logo.disabled = true;
        // Cursor
        chart.cursor = new am4charts.XYCursor();

      })

      // การมีส่วนร่วมของสมาชิกสหกรณ์ ออมทรัพย์
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_saving", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();

        let data = [];

        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "4") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_member
            })
          }
        }

        chart.data = data;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกสหกรณ ประเภทออมทรัพย์";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกสหกรณ ประเภทออมทรัพย์";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        // Create axes
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;

        categoryAxis.fontSize = "11px"
        // categoryAxis.title.text = "ปีข้อมูล"

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.minWidth = 50;
        valueAxis.fontSize = "11px"
        valueAxis.title.text = "หน่วย : คน"

        // Create series
        let series = chart.series.push(new am4charts.ColumnSeries());
        series.sequencedInterpolation = true;
        series.dataFields.valueY = "value";
        series.dataFields.categoryX = "year";
        series.tooltipText = "[{categoryX}: bold]{valueY}[/]";
        series.columns.template.strokeWidth = 0;

        series.tooltip.pointerOrientation = "vertical";

        series.columns.template.column.cornerRadiusTopLeft = 10;
        series.columns.template.column.cornerRadiusTopRight = 10;
        series.columns.template.column.fillOpacity = 0.8;

        let bullet = series.bullets.push(new am4charts.LabelBullet())
        bullet.interactionsEnabled = false
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#000')

        // on hover, make corner radiuses bigger
        let hoverState = series.columns.template.column.states.create("hover");
        hoverState.properties.cornerRadiusTopLeft = 0;
        hoverState.properties.cornerRadiusTopRight = 0;
        hoverState.properties.fillOpacity = 1;

        series.columns.template.adapter.add("fill", function (fill, target) {
          return chart.colors.getIndex(target.dataItem.index);
        });

        chart.logo.disabled = true;
        // Cursor
        chart.cursor = new am4charts.XYCursor();

      })

      // การมีส่วนร่วมของสมาชิกสหกรณ์ ร้านค้า
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_shop", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();

        let data = [];

        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "5") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_member
            })
          }
        }

        chart.data = data;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกสหกรณ ประเภทร้านค้า";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกสหกรณ ประเภทร้านค้า";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        // Create axes
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;

        categoryAxis.fontSize = "11px"
        // categoryAxis.title.text = "ปีข้อมูล"

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.minWidth = 50;
        valueAxis.fontSize = "11px"
        valueAxis.title.text = "หน่วย : คน"

        // Create series
        let series = chart.series.push(new am4charts.ColumnSeries());
        series.sequencedInterpolation = true;
        series.dataFields.valueY = "value";
        series.dataFields.categoryX = "year";
        series.tooltipText = "[{categoryX}: bold]{valueY}[/]";
        series.columns.template.strokeWidth = 0;

        series.tooltip.pointerOrientation = "vertical";

        series.columns.template.column.cornerRadiusTopLeft = 10;
        series.columns.template.column.cornerRadiusTopRight = 10;
        series.columns.template.column.fillOpacity = 0.8;

        let bullet = series.bullets.push(new am4charts.LabelBullet())
        bullet.interactionsEnabled = false
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#000')

        // on hover, make corner radiuses bigger
        let hoverState = series.columns.template.column.states.create("hover");
        hoverState.properties.cornerRadiusTopLeft = 0;
        hoverState.properties.cornerRadiusTopRight = 0;
        hoverState.properties.fillOpacity = 1;

        series.columns.template.adapter.add("fill", function (fill, target) {
          return chart.colors.getIndex(target.dataItem.index);
        });

        chart.logo.disabled = true;
        // Cursor
        chart.cursor = new am4charts.XYCursor();

      })

      // การมีส่วนร่วมของสมาชิกสหกรณ์ บริการ
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_service", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();

        let data = [];

        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "6") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_member
            })
          }
        }

        chart.data = data;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกสหกรณ ประเภทบริการ";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกสหกรณ ประเภทบริการ";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        // Create axes
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;

        categoryAxis.fontSize = "11px"
        // categoryAxis.title.text = "ปีข้อมูล"

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.minWidth = 50;
        valueAxis.fontSize = "11px"
        valueAxis.title.text = "หน่วย : คน"

        // Create series
        let series = chart.series.push(new am4charts.ColumnSeries());
        series.sequencedInterpolation = true;
        series.dataFields.valueY = "value";
        series.dataFields.categoryX = "year";
        series.tooltipText = "[{categoryX}: bold]{valueY}[/]";
        series.columns.template.strokeWidth = 0;

        series.tooltip.pointerOrientation = "vertical";

        series.columns.template.column.cornerRadiusTopLeft = 10;
        series.columns.template.column.cornerRadiusTopRight = 10;
        series.columns.template.column.fillOpacity = 0.8;

        let bullet = series.bullets.push(new am4charts.LabelBullet())
        bullet.interactionsEnabled = false
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#000')

        // on hover, make corner radiuses bigger
        let hoverState = series.columns.template.column.states.create("hover");
        hoverState.properties.cornerRadiusTopLeft = 0;
        hoverState.properties.cornerRadiusTopRight = 0;
        hoverState.properties.fillOpacity = 1;

        series.columns.template.adapter.add("fill", function (fill, target) {
          return chart.colors.getIndex(target.dataItem.index);
        });

        chart.logo.disabled = true;
        // Cursor
        chart.cursor = new am4charts.XYCursor();

      })

      // การมีส่วนร่วมของสมาชิกสหกรณ์ เครดิต
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Participation_credit", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();

        let data = [];

        for (let i = 0; i < res.length; i++) {
          if (res[i].coop_type == "7") {
            data.push({
              "year": res[i].year,
              "value": res[i].sum_member
            })
          }
        }

        chart.data = data;

        // Export
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกสหกรณ ประเภทเครดิตยูเนี่ยน";
        title.disabled = false;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกสหกรณ ประเภทเครดิตยูเนี่ยน";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);
        // Create axes
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;

        categoryAxis.fontSize = "11px"
        // categoryAxis.title.text = "ปีข้อมูล"

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.minWidth = 50;
        valueAxis.fontSize = "11px"
        valueAxis.title.text = "หน่วย : คน"

        // Create series
        let series = chart.series.push(new am4charts.ColumnSeries());
        series.sequencedInterpolation = true;
        series.dataFields.valueY = "value";
        series.dataFields.categoryX = "year";
        series.tooltipText = "[{categoryX}: bold]{valueY}[/]";
        series.columns.template.strokeWidth = 0;

        series.tooltip.pointerOrientation = "vertical";

        series.columns.template.column.cornerRadiusTopLeft = 10;
        series.columns.template.column.cornerRadiusTopRight = 10;
        series.columns.template.column.fillOpacity = 0.8;

        let bullet = series.bullets.push(new am4charts.LabelBullet())
        bullet.interactionsEnabled = false
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#000')

        // on hover, make corner radiuses bigger
        let hoverState = series.columns.template.column.states.create("hover");
        hoverState.properties.cornerRadiusTopLeft = 0;
        hoverState.properties.cornerRadiusTopRight = 0;
        hoverState.properties.fillOpacity = 1;

        series.columns.template.adapter.add("fill", function (fill, target) {
          return chart.colors.getIndex(target.dataItem.index);
        });

        chart.logo.disabled = true;
        // Cursor
        chart.cursor = new am4charts.XYCursor();

      })
    });

  }

  ngOnDestroy() {
    // Clean up chart when the component is removed

    this.zone.runOutsideAngular(() => {

      am4core.disposeAllCharts();

    });
  }

}
